{
  "level": "mt03",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt03",
    "objects": "AREAS.E3:mt03.e3",
    "mesh": "TREES.E3:mt03.e3"
  },
  "spawn_point": {
    "position": [
      -917.1151390454742,
      -2732.7152266119015,
      663.28125
    ],
    "facing_rad": 0.0,
    "look_point": [
      -917.1151390454742,
      -2632.7152266119015,
      663.28125
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1070.0,
      -3254.84521484375,
      639.28125
    ],
    "bbox_max": [
      -577.8391723632812,
      -2180.648681640625,
      863.8005981445312
    ],
    "vertex_count": 1107,
    "vertices": [
      [
        -577.8391723632812,
        -2180.648681640625,
        639.2813110351562
      ],
      [
        -602.43359375,
        -2192.60791015625,
        641.6248779296875
      ],
      [
        -599.2575073242188,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -599.7045288085938,
        -2193.9814453125,
        641.6248779296875
      ],
      [
        -598.7432250976562,
        -2194.46533203125,
        641.6248779296875
      ],
      [
        -612.2839965820312,
        -2205.430908203125,
        639.2813110351562
      ],
      [
        -578.486328125,
        -2218.885986328125,
        639.28125
      ],
      [
        -603.455810546875,
        -2215.376708984375,
        639.2813110351562
      ],
      [
        -612.2088012695312,
        -2205.376953125,
        641.6248779296875
      ],
      [
        -612.2839965820312,
        -2205.430908203125,
        639.2813110351562
      ],
      [
        -615.3544921875,
        -2201.833251953125,
        641.6248779296875
      ],
      [
        -612.2088012695312,
        -2205.376953125,
        641.6248779296875
      ],
      [
        -622.4407958984375,
        -2212.70849609375,
        639.2813110351562
      ],
      [
        -629.2466430664062,
        -2211.751953125,
        641.6248779296875
      ],
      [
        -622.4407958984375,
        -2212.70849609375,
        641.6248779296875
      ],
      [
        -622.4407958984375,
        -2212.70849609375,
        641.6248779296875
      ],
      [
        -622.4407958984375,
        -2212.70849609375,
        639.2813110351562
      ],
      [
        -1067.8572998046875,
        -3254.84521484375,
        862.6844482421875
      ],
      [
        -1025.7139892578125,
        -3242.22021484375,
        856.9961547851562
      ],
      [
        -947.423095703125,
        -3064.909423828125,
        812.885009765625
      ],
      [
        -949.54150390625,
        -3064.459228515625,
        815.4678955078125
      ],
      [
        -947.423095703125,
        -3064.909423828125,
        812.885009765625
      ],
      [
        -945.7866821289062,
        -3065.25732421875,
        812.95751953125
      ],
      [
        -905.2670288085938,
        -3073.869873046875,
        812.7454833984375
      ],
      [
        -944.3916015625,
        -3065.553955078125,
        813.0193481445312
      ],
      [
        -944.3916015625,
        -3065.553955078125,
        813.0193481445312
      ],
      [
        -892.0865478515625,
        -3076.67138671875,
        824.6702270507812
      ],
      [
        -905.2670288085938,
        -3073.869873046875,
        812.7454833984375
      ],
      [
        -954.8323364257812,
        -3063.33447265625,
        821.918701171875
      ],
      [
        -762.9453125,
        -2320.06591796875,
        639.4368896484375
      ],
      [
        -756.9136962890625,
        -2325.25537109375,
        639.4420776367188
      ],
      [
        -719.9760131835938,
        -2357.03564453125,
        639.4241333007812
      ],
      [
        -756.9136962890625,
        -2325.25537109375,
        639.4420776367188
      ],
      [
        -758.0178833007812,
        -2324.30517578125,
        686.6820068359375
      ],
      [
        -731.4839477539062,
        -2347.13427734375,
        686.9557495117188
      ],
      [
        -811.7867431640625,
        -2443.322509765625,
        687.7288208007812
      ],
      [
        -804.6386108398438,
        -2437.501708984375,
        687.4734497070312
      ],
      [
        -836.911376953125,
        -2429.963623046875,
        687.8262939453125
      ],
      [
        -806.7801513671875,
        -2445.984619140625,
        687.719482421875
      ],
      [
        -802.5704345703125,
        -2439.760498046875,
        687.498779296875
      ],
      [
        -804.6386108398438,
        -2437.501708984375,
        687.4734497070312
      ],
      [
        -811.7867431640625,
        -2443.322509765625,
        687.7288208007812
      ],
      [
        -802.5712890625,
        -2439.76171875,
        687.498779296875
      ],
      [
        -806.7801513671875,
        -2445.984619140625,
        687.719482421875
      ],
      [
        -806.7734985351562,
        -2445.98828125,
        687.7094116210938
      ],
      [
        -802.7054443359375,
        -2439.968017578125,
        687.5000610351562
      ],
      [
        -837.3421630859375,
        -2429.734619140625,
        687.3051147460938
      ],
      [
        -836.911376953125,
        -2429.963623046875,
        687.8262939453125
      ],
      [
        -806.6600952148438,
        -2446.04833984375,
        687.5380249023438
      ],
      [
        -758.0178833007812,
        -2324.30517578125,
        686.6820068359375
      ],
      [
        -758.9638671875,
        -2323.491455078125,
        684.7988891601562
      ],
      [
        -768.8766479492188,
        -2314.962646484375,
        674.0292358398438
      ],
      [
        -758.9638671875,
        -2323.491455078125,
        684.7988891601562
      ],
      [
        -768.8766479492188,
        -2314.962646484375,
        674.0292358398438
      ],
      [
        -768.3580932617188,
        -2315.40869140625,
        666.0977783203125
      ],
      [
        -730.0579223632812,
        -2348.361083984375,
        686.9561767578125
      ],
      [
        -731.4839477539062,
        -2347.13427734375,
        686.9557495117188
      ],
      [
        -802.7054443359375,
        -2439.968017578125,
        687.5000610351562
      ],
      [
        -837.3992309570312,
        -2429.704345703125,
        687.2360229492188
      ],
      [
        -806.4542846679688,
        -2446.15771484375,
        687.2269287109375
      ],
      [
        -766.5195922851562,
        -2316.99072265625,
        648.671630859375
      ],
      [
        -767.4364013671875,
        -2316.20166015625,
        652.0009155273438
      ],
      [
        -767.4364013671875,
        -2316.20166015625,
        652.0009155273438
      ],
      [
        -762.9453125,
        -2320.06591796875,
        639.4368896484375
      ],
      [
        -766.5195922851562,
        -2316.99072265625,
        648.671630859375
      ],
      [
        -717.7279663085938,
        -2358.969482421875,
        674.4885864257812
      ],
      [
        -717.3270263671875,
        -2359.314453125,
        675.9419555664062
      ],
      [
        -798.2432250976562,
        -2450.52392578125,
        640.5693969726562
      ],
      [
        -791.960205078125,
        -2453.86474609375,
        660.1710815429688
      ],
      [
        -790.6174926757812,
        -2454.57861328125,
        664.1052856445312
      ],
      [
        -791.960205078125,
        -2453.86474609375,
        660.1710815429688
      ],
      [
        -790.6174926757812,
        -2454.57861328125,
        664.1052856445312
      ],
      [
        -790.6756591796875,
        -2454.547607421875,
        664.1784057617188
      ],
      [
        -798.2432250976562,
        -2450.52392578125,
        640.5693969726562
      ],
      [
        -799.2250366210938,
        -2450.001953125,
        640.570068359375
      ],
      [
        -791.3250732421875,
        -2454.202392578125,
        664.99462890625
      ],
      [
        -844.3095703125,
        -2426.030029296875,
        640.658935546875
      ],
      [
        -806.9904174804688,
        -2445.872802734375,
        640.5751342773438
      ],
      [
        -852.0359497070312,
        -2421.921875,
        664.2813110351562
      ],
      [
        -841.2787475585938,
        -2427.641357421875,
        682.542236328125
      ],
      [
        -846.2428588867188,
        -2425.002197265625,
        646.314208984375
      ],
      [
        -852.0359497070312,
        -2421.921875,
        664.2813110351562
      ],
      [
        -793.8185424804688,
        -2452.876708984375,
        668.1284790039062
      ],
      [
        -793.8185424804688,
        -2452.876708984375,
        668.1284790039062
      ],
      [
        -844.3095703125,
        -2426.030029296875,
        640.658935546875
      ],
      [
        -846.2428588867188,
        -2425.002197265625,
        646.314208984375
      ],
      [
        -841.2787475585938,
        -2427.641357421875,
        682.542236328125
      ],
      [
        -806.9904174804688,
        -2445.872802734375,
        640.5751342773438
      ],
      [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      [
        -753.8582153320312,
        -2300.75,
        641.6248779296875
      ],
      [
        -764.4830932617188,
        -2318.742919921875,
        643.409912109375
      ],
      [
        -767.5608520507812,
        -2316.0947265625,
        675.458740234375
      ],
      [
        -754.3849487304688,
        -2307.2509765625,
        641.6248779296875
      ],
      [
        -752.0360107421875,
        -2304.23291015625,
        641.6248779296875
      ],
      [
        -758.0213623046875,
        -2309.856689453125,
        679.4390258789062
      ],
      [
        -767.1821899414062,
        -2316.42041015625,
        675.8701171875
      ],
      [
        -760.9716186523438,
        -2311.970458984375,
        646.1329345703125
      ],
      [
        -762.9484252929688,
        -2320.063232421875,
        639.4450073242188
      ],
      [
        -842.8680419921875,
        -2532.747802734375,
        675.0084838867188
      ],
      [
        -858.8065795898438,
        -2524.273193359375,
        695.8198852539062
      ],
      [
        -863.0928344726562,
        -2521.994140625,
        695.9338989257812
      ],
      [
        -858.8065795898438,
        -2524.273193359375,
        695.8198852539062
      ],
      [
        -838.7605590820312,
        -2534.931640625,
        669.04052734375
      ],
      [
        -842.8680419921875,
        -2532.747802734375,
        675.0084838867188
      ],
      [
        -838.7605590820312,
        -2534.931640625,
        669.04052734375
      ],
      [
        -839.5821533203125,
        -2534.494873046875,
        666.0324096679688
      ],
      [
        -809.40966796875,
        -2444.58642578125,
        687.724365234375
      ],
      [
        -863.3790283203125,
        -2521.842041015625,
        695.9415283203125
      ],
      [
        -846.969482421875,
        -2530.56689453125,
        643.8728637695312
      ],
      [
        -840.2496948242188,
        -2534.139892578125,
        663.588134765625
      ],
      [
        -846.969482421875,
        -2530.56689453125,
        643.8728637695312
      ],
      [
        -847.32568359375,
        -2530.37744140625,
        643.8756103515625
      ],
      [
        -840.2496948242188,
        -2534.139892578125,
        663.588134765625
      ],
      [
        -879.661376953125,
        -2513.1845703125,
        696.3748168945312
      ],
      [
        -883.9695434570312,
        -2510.893798828125,
        695.8771362304688
      ],
      [
        -879.661376953125,
        -2513.1845703125,
        696.3748168945312
      ],
      [
        -883.9695434570312,
        -2510.893798828125,
        695.8771362304688
      ],
      [
        -888.3395385742188,
        -2508.5703125,
        690.536865234375
      ],
      [
        -836.9530029296875,
        -2429.94140625,
        687.7759399414062
      ],
      [
        -900.268310546875,
        -2502.2275390625,
        675.9594116210938
      ],
      [
        -904.4310913085938,
        -2500.01416015625,
        668.8807983398438
      ],
      [
        -900.268310546875,
        -2502.2275390625,
        675.9594116210938
      ],
      [
        -904.4310913085938,
        -2500.01416015625,
        668.8807983398438
      ],
      [
        -904.1784057617188,
        -2500.1484375,
        667.9860229492188
      ],
      [
        -885.7332153320312,
        -2509.9560546875,
        644.1735229492188
      ],
      [
        -885.7332153320312,
        -2509.9560546875,
        644.1735229492188
      ],
      [
        -896.2223510742188,
        -2504.37890625,
        643.792724609375
      ],
      [
        -896.2223510742188,
        -2504.37890625,
        643.792724609375
      ],
      [
        -896.3795776367188,
        -2504.29541015625,
        644.2561645507812
      ],
      [
        -902.9319458007812,
        -2500.811279296875,
        663.5715942382812
      ],
      [
        -902.9319458007812,
        -2500.811279296875,
        663.5715942382812
      ],
      [
        -918.32568359375,
        -2575.4931640625,
        717.738525390625
      ],
      [
        -941.46484375,
        -2571.4130859375,
        685.9884033203125
      ],
      [
        -915.2291870117188,
        -2576.0390625,
        725.8607788085938
      ],
      [
        -918.32568359375,
        -2575.4931640625,
        717.738525390625
      ],
      [
        -915.2291870117188,
        -2576.0390625,
        725.8607788085938
      ],
      [
        -912.107177734375,
        -2576.589599609375,
        726.2710571289062
      ],
      [
        -941.46484375,
        -2571.4130859375,
        685.9884033203125
      ],
      [
        -940.4493408203125,
        -2571.592041015625,
        684.4713745117188
      ],
      [
        -910.4232788085938,
        -2576.886474609375,
        726.4923095703125
      ],
      [
        -846.3800048828125,
        -2530.88037109375,
        645.602294921875
      ],
      [
        -910.0775756835938,
        -2576.947509765625,
        726.5377197265625
      ],
      [
        -860.8630981445312,
        -2585.62548828125,
        684.910888671875
      ],
      [
        -884.07763671875,
        -2581.53173828125,
        717.5496826171875
      ],
      [
        -888.8445434570312,
        -2580.69140625,
        726.1139526367188
      ],
      [
        -884.07763671875,
        -2581.53173828125,
        717.5496826171875
      ],
      [
        -888.8445434570312,
        -2580.69140625,
        726.1139526367188
      ],
      [
        -890.2044677734375,
        -2580.45166015625,
        726.163818359375
      ],
      [
        -894.9523315429688,
        -2579.614501953125,
        726.3378295898438
      ],
      [
        -860.8630981445312,
        -2585.62548828125,
        684.910888671875
      ],
      [
        -861.900634765625,
        -2585.442626953125,
        682.1506958007812
      ],
      [
        -938.7445068359375,
        -2571.892578125,
        681.924560546875
      ],
      [
        -907.9686279296875,
        -2577.3193359375,
        726.8148803710938
      ],
      [
        -907.9686279296875,
        -2577.3193359375,
        726.8148803710938
      ],
      [
        -870.6910400390625,
        -2583.89208984375,
        654.4735717773438
      ],
      [
        -862.2821655273438,
        -2585.375244140625,
        681.1356811523438
      ],
      [
        -862.2821655273438,
        -2585.375244140625,
        681.1356811523438
      ],
      [
        -870.6910400390625,
        -2583.89208984375,
        654.4735717773438
      ],
      [
        -873.1616821289062,
        -2583.45654296875,
        654.5232543945312
      ],
      [
        -916.9639282226562,
        -2575.733154296875,
        655.4043579101562
      ],
      [
        -929.5636596679688,
        -2573.511474609375,
        655.013916015625
      ],
      [
        -916.9639282226562,
        -2575.733154296875,
        655.4043579101562
      ],
      [
        -929.5636596679688,
        -2573.511474609375,
        655.013916015625
      ],
      [
        -929.7709350585938,
        -2573.474853515625,
        655.6619262695312
      ],
      [
        -937.6468505859375,
        -2572.086181640625,
        680.2847900390625
      ],
      [
        -937.6468505859375,
        -2572.086181640625,
        680.2847900390625
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      [
        -985.4205932617188,
        -2640.0,
        705.8635864257812
      ],
      [
        -985.4205932617188,
        -2640.0,
        705.8635864257812
      ],
      [
        -940.1668090820312,
        -2580.30615234375,
        678.852294921875
      ],
      [
        -984.8797607421875,
        -2640.0,
        705.1128540039062
      ],
      [
        -940.1668090820312,
        -2580.30615234375,
        678.852294921875
      ],
      [
        -935.3463745117188,
        -2572.491943359375,
        673.0926513671875
      ],
      [
        -957.8712158203125,
        -2640.0,
        666.6993408203125
      ],
      [
        -881.5084838867188,
        -2640.0,
        666.6993408203125
      ],
      [
        -878.090576171875,
        -2640.0,
        666.505859375
      ],
      [
        -881.5084838867188,
        -2640.0,
        666.6993408203125
      ],
      [
        -878.090576171875,
        -2640.0,
        666.505859375
      ],
      [
        -869.9378662109375,
        -2584.02490234375,
        656.8616333007812
      ],
      [
        -878.0274047851562,
        -2640.0,
        666.6993408203125
      ],
      [
        -958.4671630859375,
        -2640.0,
        668.449462890625
      ],
      [
        -957.8712158203125,
        -2640.0,
        666.6993408203125
      ],
      [
        -958.4671630859375,
        -2640.0,
        668.449462890625
      ],
      [
        -882.9166870117188,
        -2640.0,
        742.6649169921875
      ],
      [
        -864.775634765625,
        -2640.0,
        708.57958984375
      ],
      [
        -862.9345092773438,
        -2640.0,
        705.8839111328125
      ],
      [
        -864.775634765625,
        -2640.0,
        708.57958984375
      ],
      [
        -882.9166870117188,
        -2640.0,
        742.6649169921875
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -895.7581787109375,
        -2640.0,
        767.9290771484375
      ],
      [
        -897.95458984375,
        -2640.0,
        770.9197387695312
      ],
      [
        -862.90673828125,
        -2587.63671875,
        680.6214599609375
      ],
      [
        -862.9345092773438,
        -2640.0,
        705.8839111328125
      ],
      [
        -863.1060180664062,
        -2640.0,
        705.4422607421875
      ],
      [
        -862.83447265625,
        -2585.27783203125,
        679.3844604492188
      ],
      [
        -862.90673828125,
        -2587.63671875,
        680.6214599609375
      ],
      [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -968.2777709960938,
        -2640.0,
        742.4426879882812
      ],
      [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      [
        -952.3094482421875,
        -2640.0,
        771.9608154296875
      ],
      [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      [
        -898.71923828125,
        -2640.0,
        771.9608154296875
      ],
      [
        -977.0639038085938,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -959.8472290039062,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -903.5572509765625,
        -2859.5,
        761.111083984375
      ],
      [
        -941.3390502929688,
        -2859.5,
        761.111083984375
      ],
      [
        -966.0363159179688,
        -2920.0,
        788.0
      ],
      [
        -877.9636840820312,
        -2920.0,
        788.0
      ],
      [
        -906.0615234375,
        -2930.0,
        790.5328369140625
      ],
      [
        -933.5289916992188,
        -2930.0,
        790.5328369140625
      ],
      [
        -940.072265625,
        -2930.0,
        790.5327758789062
      ],
      [
        -939.038330078125,
        -2930.0,
        790.4069213867188
      ],
      [
        -933.5289916992188,
        -2930.0,
        790.5328369140625
      ],
      [
        -903.927734375,
        -2930.0,
        790.5327758789062
      ],
      [
        -939.038330078125,
        -2930.0,
        790.4069213867188
      ],
      [
        -939.1234741210938,
        -2930.0,
        790.5327758789062
      ],
      [
        -941.6363525390625,
        -2930.0,
        792.4444580078125
      ],
      [
        -902.3636474609375,
        -2930.0,
        792.4444580078125
      ],
      [
        -940.416259765625,
        -2930.0,
        792.4444580078125
      ],
      [
        -906.0615234375,
        -2930.0,
        790.5328369140625
      ],
      [
        -904.2719116210938,
        -2930.0,
        792.4444580078125
      ],
      [
        -932.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -932.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -890.9091186523438,
        -2895.0,
        825.9469604492188
      ],
      [
        -876.742431640625,
        -2895.0,
        805.7197265625
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -871.2230224609375,
        -2859.5,
        792.1477661132812
      ],
      [
        -869.7720336914062,
        -2859.5,
        790.45849609375
      ],
      [
        -869.8526611328125,
        -2859.5,
        790.1912231445312
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -869.8880004882812,
        -2859.5,
        790.0740966796875
      ],
      [
        -871.8587036132812,
        -2859.5,
        792.8878784179688
      ],
      [
        -903.7879028320312,
        -2895.0,
        838.9867553710938
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -932.0,
        -2895.0,
        838.9867553710938
      ],
      [
        -914.0,
        -2859.5,
        832.9804077148438
      ],
      [
        -914.0,
        -2895.0,
        838.9867553710938
      ],
      [
        -914.0,
        -2895.0,
        843.5
      ],
      [
        -932.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -932.0,
        -2895.0,
        830.6638793945312
      ],
      [
        -914.0,
        -2895.0,
        830.6638793945312
      ],
      [
        -914.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -914.0,
        -2895.0,
        834.6638793945312
      ],
      [
        -932.0,
        -2895.0,
        834.6638793945312
      ],
      [
        -932.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -914.0,
        -2859.5,
        817.4066162109375
      ],
      [
        -914.0,
        -2895.0,
        830.6638793945312
      ],
      [
        -914.0,
        -2895.0,
        834.6638793945312
      ],
      [
        -914.0,
        -2859.5,
        821.4066162109375
      ],
      [
        -899.5184326171875,
        -2895.0,
        834.6638793945312
      ],
      [
        -895.5677490234375,
        -2895.0,
        830.6638793945312
      ],
      [
        -893.0647583007812,
        -2887.3095703125,
        827.7918701171875
      ],
      [
        -894.892822265625,
        -2880.787841796875,
        829.3564453125
      ],
      [
        -914.0,
        -2895.0,
        834.6638793945312
      ],
      [
        -932.0,
        -2863.125,
        833.59375
      ],
      [
        -914.0,
        -2863.125,
        833.59375
      ],
      [
        -914.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -903.7879028320312,
        -2895.0,
        838.9867553710938
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -906.3441162109375,
        -2859.5,
        832.5732421875
      ],
      [
        -899.6533813476562,
        -2859.5,
        832.5732421875
      ],
      [
        -880.9041748046875,
        -2895.0,
        791.0235595703125
      ],
      [
        -885.197998046875,
        -2895.0,
        776.8888549804688
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -877.9344482421875,
        -2859.5,
        763.3938598632812
      ],
      [
        -878.493408203125,
        -2859.5,
        761.111083984375
      ],
      [
        -876.742431640625,
        -2895.0,
        805.7197265625
      ],
      [
        -880.9041748046875,
        -2895.0,
        791.0235595703125
      ],
      [
        -890.9091186523438,
        -2895.0,
        825.9469604492188
      ],
      [
        -932.0,
        -2920.0,
        863.8005981445312
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -906.88134765625,
        -2920.0,
        843.216552734375
      ],
      [
        -883.9014892578125,
        -2920.0,
        819.949462890625
      ],
      [
        -908.3773803710938,
        -2930.0,
        845.7208251953125
      ],
      [
        -886.190185546875,
        -2930.0,
        823.2562255859375
      ],
      [
        -883.5282592773438,
        -2930.0,
        820.9566040039062
      ],
      [
        -886.190185546875,
        -2930.0,
        823.2562255859375
      ],
      [
        -883.5282592773438,
        -2930.0,
        820.9566040039062
      ],
      [
        -883.4671020507812,
        -2930.0,
        820.4992065429688
      ],
      [
        -908.3773803710938,
        -2930.0,
        845.7208251953125
      ],
      [
        -908.9210815429688,
        -2930.0,
        845.7208251953125
      ],
      [
        -883.3820190429688,
        -2930.0,
        819.862548828125
      ],
      [
        -881.5404052734375,
        -2920.0,
        816.5783081054688
      ],
      [
        -888.9662475585938,
        -2920.0,
        790.3557739257812
      ],
      [
        -890.6571655273438,
        -2930.0,
        792.7325439453125
      ],
      [
        -883.2512817382812,
        -2930.0,
        818.8846435546875
      ],
      [
        -890.6571655273438,
        -2930.0,
        792.7325439453125
      ],
      [
        -891.4382934570312,
        -2930.0,
        792.7470703125
      ],
      [
        -883.2512817382812,
        -2930.0,
        818.8846435546875
      ],
      [
        -932.0,
        -2930.0,
        838.0
      ],
      [
        -932.0,
        -2920.0,
        838.0
      ],
      [
        -906.88134765625,
        -2920.0,
        843.216552734375
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -932.0,
        -2925.0,
        844.0625
      ],
      [
        -932.0,
        -2925.0,
        844.0625
      ],
      [
        -932.0,
        -2930.0,
        845.7208251953125
      ],
      [
        -883.9014892578125,
        -2920.0,
        819.949462890625
      ],
      [
        -881.5404052734375,
        -2920.0,
        816.5783081054688
      ],
      [
        -894.0,
        -2923.890625,
        789.7291870117188
      ],
      [
        -894.0,
        -2930.0,
        792.794677734375
      ],
      [
        -888.9662475585938,
        -2920.0,
        790.3557739257812
      ],
      [
        -889.681884765625,
        -2920.0,
        788.0
      ],
      [
        -901.9560546875,
        -2930.0,
        792.9425659179688
      ],
      [
        -903.77392578125,
        -2930.0,
        792.9763793945312
      ],
      [
        -903.77392578125,
        -2930.0,
        792.9763793945312
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -914.0,
        -2895.0,
        838.9867553710938
      ],
      [
        -914.0,
        -2920.0,
        843.216552734375
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -914.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -932.0,
        -2916.164306640625,
        842.5675659179688
      ],
      [
        -973.1060791015625,
        -2895.0,
        805.7197265625
      ],
      [
        -957.727294921875,
        -2895.0,
        825.9469604492188
      ],
      [
        -985.7762451171875,
        -2859.5,
        790.45849609375
      ],
      [
        -985.7095336914062,
        -2859.5,
        790.23095703125
      ],
      [
        -985.7762451171875,
        -2859.5,
        790.45849609375
      ],
      [
        -984.927490234375,
        -2859.5,
        791.2595825195312
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      [
        -985.5738525390625,
        -2859.5,
        789.768310546875
      ],
      [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      [
        -964.7798461914062,
        -2895.0,
        776.8888549804688
      ],
      [
        -968.9443359375,
        -2895.0,
        791.0235595703125
      ],
      [
        -977.84033203125,
        -2859.5,
        763.3938598632812
      ],
      [
        -977.0639038085938,
        -2859.5,
        761.111083984375
      ],
      [
        -977.84033203125,
        -2859.5,
        763.3938598632812
      ],
      [
        -968.9443359375,
        -2895.0,
        791.0235595703125
      ],
      [
        -973.1060791015625,
        -2895.0,
        805.7197265625
      ],
      [
        -944.8485107421875,
        -2895.0,
        838.9867553710938
      ],
      [
        -932.0,
        -2895.0,
        838.9867553710938
      ],
      [
        -944.8485107421875,
        -2895.0,
        838.9867553710938
      ],
      [
        -957.727294921875,
        -2895.0,
        825.9469604492188
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -953.0294189453125,
        -2859.5,
        832.5732421875
      ],
      [
        -943.8286743164062,
        -2859.5,
        832.5732421875
      ],
      [
        -972.8995361328125,
        -2920.0,
        808.6144409179688
      ],
      [
        -956.4358520507812,
        -2920.0,
        825.283935546875
      ],
      [
        -956.4358520507812,
        -2920.0,
        825.283935546875
      ],
      [
        -939.9972534179688,
        -2920.0,
        841.9281005859375
      ],
      [
        -939.9972534179688,
        -2920.0,
        841.9281005859375
      ],
      [
        -932.0,
        -2920.0,
        850.0252685546875
      ],
      [
        -962.0082397460938,
        -2930.0,
        820.943359375
      ],
      [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      [
        -937.571044921875,
        -2930.0,
        845.6749267578125
      ],
      [
        -935.4811401367188,
        -2930.0,
        845.7122802734375
      ],
      [
        -937.571044921875,
        -2930.0,
        845.6749267578125
      ],
      [
        -939.4589233398438,
        -2930.0,
        843.7745361328125
      ],
      [
        -962.0082397460938,
        -2930.0,
        820.943359375
      ],
      [
        -961.9993286132812,
        -2930.0,
        818.93994140625
      ],
      [
        -961.9822998046875,
        -2930.0,
        818.8798828125
      ],
      [
        -961.9993286132812,
        -2930.0,
        818.93994140625
      ],
      [
        -954.5962524414062,
        -2930.0,
        792.7979125976562
      ],
      [
        -956.1746826171875,
        -2920.0,
        788.0
      ],
      [
        -959.5332641601562,
        -2920.0,
        799.8597412109375
      ],
      [
        -959.5332641601562,
        -2920.0,
        799.8597412109375
      ],
      [
        -964.4384155273438,
        -2920.0,
        817.1813354492188
      ],
      [
        -952.7792358398438,
        -2930.0,
        792.8374633789062
      ],
      [
        -954.5962524414062,
        -2930.0,
        792.7979125976562
      ],
      [
        -961.7053833007812,
        -2920.0,
        819.9485473632812
      ],
      [
        -964.2677001953125,
        -2920.0,
        816.5784301757812
      ],
      [
        -956.1475219726562,
        -2920.0,
        788.0
      ],
      [
        -956.8463745117188,
        -2920.0,
        790.3719482421875
      ],
      [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      [
        -938.7247314453125,
        -2920.0,
        843.216552734375
      ],
      [
        -935.0020141601562,
        -2930.0,
        845.7208251953125
      ],
      [
        -935.0020141601562,
        -2930.0,
        845.7208251953125
      ],
      [
        -950.0,
        -2930.0,
        792.89794921875
      ],
      [
        -950.0,
        -2923.65380859375,
        789.6239013671875
      ],
      [
        -942.1470947265625,
        -2930.0,
        793.0687255859375
      ],
      [
        -940.857421875,
        -2930.0,
        793.0968017578125
      ],
      [
        -940.857421875,
        -2930.0,
        793.0968017578125
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        670.0
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -970.0,
        -2712.0,
        720.0
      ],
      [
        -981.5535278320312,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -970.0,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -970.0,
        -2677.65380859375,
        680.2904663085938
      ],
      [
        -990.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -970.0,
        -2677.65380859375,
        680.2904663085938
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -994.123291015625,
        -2682.291259765625,
        694.1002197265625
      ],
      [
        -1007.907958984375,
        -2697.0,
        720.0
      ],
      [
        -1007.4884643554688,
        -2695.500244140625,
        720.0
      ],
      [
        -1007.907958984375,
        -2697.0,
        720.0
      ],
      [
        -1007.45263671875,
        -2700.84130859375,
        720.0
      ],
      [
        -1006.3765869140625,
        -2710.0,
        720.0
      ],
      [
        -1007.45263671875,
        -2700.84130859375,
        720.0
      ],
      [
        -981.5535278320312,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -994.123291015625,
        -2682.291259765625,
        694.1002197265625
      ],
      [
        -990.0,
        -2710.0,
        748.4310302734375
      ],
      [
        -972.8922729492188,
        -2710.0,
        748.4310302734375
      ],
      [
        -1020.0,
        -2710.0,
        748.4310302734375
      ],
      [
        -990.0,
        -2710.0,
        748.4310302734375
      ],
      [
        -972.8922729492188,
        -2710.0,
        748.4310302734375
      ],
      [
        -980.0,
        -2712.0,
        720.0
      ],
      [
        -971.9118041992188,
        -2712.0,
        752.3527221679688
      ],
      [
        -1011.9400024414062,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -1000.169921875,
        -2710.0,
        748.4310913085938
      ],
      [
        -1011.9400024414062,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -1010.0033569335938,
        -2698.625732421875,
        726.1282958984375
      ],
      [
        -1009.0059204101562,
        -2697.0,
        722.940673828125
      ],
      [
        -1010.0033569335938,
        -2698.625732421875,
        726.1282958984375
      ],
      [
        -1009.0059204101562,
        -2697.0,
        722.940673828125
      ],
      [
        -968.076904296875,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -870.4964599609375,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -865.0618896484375,
        -2712.0,
        695.5555419921875
      ],
      [
        -968.076904296875,
        -2674.54345703125,
        678.9081420898438
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -896.08935546875,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -897.6017456054688,
        -2712.0,
        695.5555419921875
      ],
      [
        -949.479736328125,
        -2712.0,
        695.5555419921875
      ],
      [
        -951.5470581054688,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -894.0,
        -2712.0,
        670.0
      ],
      [
        -894.0,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -894.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -836.0967407226562,
        -2712.0,
        718.0
      ],
      [
        -836.8701171875,
        -2708.11181640625,
        744.7284545898438
      ],
      [
        -836.0967407226562,
        -2712.0,
        752.3526000976562
      ],
      [
        -840.77197265625,
        -2702.27197265625,
        733.2783813476562
      ],
      [
        -836.8701171875,
        -2708.11181640625,
        744.7284545898438
      ],
      [
        -853.0,
        -2697.099365234375,
        718.0
      ],
      [
        -836.0967407226562,
        -2712.0,
        718.0
      ],
      [
        -853.0,
        -2712.0,
        718.0
      ],
      [
        -877.0875244140625,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -870.0,
        -2712.0,
        720.0
      ],
      [
        -877.0875244140625,
        -2712.0,
        720.0
      ],
      [
        -894.0,
        -2712.0,
        720.0
      ],
      [
        -885.9562377929688,
        -2712.0,
        720.0
      ],
      [
        -856.3112182617188,
        -2697.0,
        720.0
      ],
      [
        -864.9321899414062,
        -2682.35205078125,
        694.219482421875
      ],
      [
        -856.40234375,
        -2695.500244140625,
        720.0
      ],
      [
        -856.8702392578125,
        -2697.67041015625,
        718.0
      ],
      [
        -855.9998168945312,
        -2712.0,
        718.0
      ],
      [
        -864.9321899414062,
        -2682.35205078125,
        694.219482421875
      ],
      [
        -870.4964599609375,
        -2674.543212890625,
        678.9081420898438
      ],
      [
        -870.9032592773438,
        -2712.0,
        718.0
      ],
      [
        -872.3709716796875,
        -2712.0,
        752.3528442382812
      ],
      [
        -872.3709716796875,
        -2712.0,
        720.0
      ],
      [
        -868.5,
        -2700.0,
        728.8235473632812
      ],
      [
        -865.2177734375,
        -2712.0,
        752.3527221679688
      ],
      [
        -853.125,
        -2712.0,
        735.8872680664062
      ],
      [
        -853.125,
        -2701.77294921875,
        732.2994384765625
      ],
      [
        -868.5,
        -2700.0,
        728.8235473632812
      ],
      [
        -855.4293823242188,
        -2697.0,
        722.940673828125
      ],
      [
        -856.3504028320312,
        -2696.355224609375,
        720.0
      ],
      [
        -855.9296264648438,
        -2696.22900390625,
        721.4287109375
      ],
      [
        -858.5,
        -2650.0,
        668.0
      ],
      [
        -991.0,
        -2650.0,
        668.0
      ],
      [
        -836.0967407226562,
        -2712.0,
        765.0
      ],
      [
        -932.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -932.0,
        -2640.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        757.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -932.0,
        -2645.0,
        667.578125
      ],
      [
        -932.0,
        -2640.0,
        666.6993408203125
      ],
      [
        -895.098388671875,
        -2647.400634765625,
        668.0
      ],
      [
        -932.0,
        -2650.0,
        668.0
      ],
      [
        -932.0,
        -2647.400634765625,
        668.0
      ],
      [
        -878.0274047851562,
        -2640.0,
        666.6993408203125
      ],
      [
        -875.80322265625,
        -2650.0,
        668.0
      ],
      [
        -876.2950439453125,
        -2645.0,
        667.578125
      ],
      [
        -875.9871215820312,
        -2647.400390625,
        668.0
      ],
      [
        -895.098388671875,
        -2647.400634765625,
        668.0
      ],
      [
        -894.743408203125,
        -2650.0,
        668.4568481445312
      ],
      [
        -875.6536865234375,
        -2650.0,
        668.4568481445312
      ],
      [
        -862.1634521484375,
        -2650.0,
        710.0059814453125
      ],
      [
        -890.2030639648438,
        -2640.0,
        757.0
      ],
      [
        -886.0501098632812,
        -2650.0,
        757.0
      ],
      [
        -863.1060180664062,
        -2640.0,
        705.4423217773438
      ],
      [
        -863.4917602539062,
        -2640.0,
        704.4490356445312
      ],
      [
        -863.366943359375,
        -2650.0,
        705.992919921875
      ],
      [
        -862.1634521484375,
        -2650.0,
        710.0059814453125
      ],
      [
        -863.366943359375,
        -2650.0,
        705.992919921875
      ],
      [
        -932.0,
        -2640.0,
        748.0
      ],
      [
        -932.0,
        -2650.0,
        748.0
      ],
      [
        -932.0,
        -2640.0,
        668.0
      ],
      [
        -860.2403564453125,
        -2660.0,
        714.3930053710938
      ],
      [
        -883.2678833007812,
        -2656.699462890625,
        757.0
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -863.8507690429688,
        -2660.0,
        702.353759765625
      ],
      [
        -873.6409912109375,
        -2660.0,
        672.4444580078125
      ],
      [
        -914.0,
        -2660.0,
        754.0
      ],
      [
        -932.0,
        -2660.0,
        754.0
      ],
      [
        -932.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        750.0
      ],
      [
        -914.0,
        -2660.0,
        754.0
      ],
      [
        -860.2403564453125,
        -2660.0,
        714.3930053710938
      ],
      [
        -863.8507690429688,
        -2660.0,
        702.353759765625
      ],
      [
        -880.7991943359375,
        -2660.0,
        754.8399047851562
      ],
      [
        -883.2678833007812,
        -2656.699462890625,
        757.0
      ],
      [
        -882.3856201171875,
        -2660.0,
        757.0
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2640.0,
        771.9608154296875
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -927.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -921.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -915.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -909.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -921.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -921.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -927.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -921.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -915.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -909.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -898.5655517578125,
        -2660.0,
        779.0304565429688
      ],
      [
        -853.5,
        -2695.5,
        730.5894775390625
      ],
      [
        -868.5,
        -2700.0,
        752.6513061523438
      ],
      [
        -872.3709716796875,
        -2712.0,
        792.0
      ],
      [
        -872.3709716796875,
        -2712.0,
        762.2891845703125
      ],
      [
        -868.5,
        -2700.0,
        752.6513061523438
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -858.517822265625,
        -2697.00537109375,
        737.9696044921875
      ],
      [
        -868.5,
        -2700.0,
        752.6119384765625
      ],
      [
        -872.3709716796875,
        -2712.0,
        762.0924682617188
      ],
      [
        -868.5,
        -2700.0,
        752.6119384765625
      ],
      [
        -853.5,
        -2695.5,
        730.1375732421875
      ],
      [
        -854.1092529296875,
        -2695.682861328125,
        731.485595703125
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -853.5,
        -2695.5,
        729.6782836914062
      ],
      [
        -855.9295043945312,
        -2696.228759765625,
        721.4291381835938
      ],
      [
        -932.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -914.0,
        -2668.288818359375,
        750.0
      ],
      [
        -914.0,
        -2712.0,
        762.3236694335938
      ],
      [
        -914.0,
        -2712.0,
        766.3236694335938
      ],
      [
        -932.0,
        -2668.288818359375,
        750.0
      ],
      [
        -914.0,
        -2668.288818359375,
        750.0
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.4685668945312
      ],
      [
        -932.0,
        -2697.0,
        792.109375
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -897.8980712890625,
        -2712.0,
        795.468505859375
      ],
      [
        -890.8987426757812,
        -2712.0,
        787.3197021484375
      ],
      [
        -990.860595703125,
        -2650.0,
        709.5540771484375
      ],
      [
        -967.8666381835938,
        -2650.0,
        757.0
      ],
      [
        -961.2227783203125,
        -2640.0,
        757.0
      ],
      [
        -965.4456787109375,
        -2650.0,
        668.0
      ],
      [
        -989.3621826171875,
        -2650.0,
        705.541015625
      ],
      [
        -957.2064208984375,
        -2640.0,
        666.6993408203125
      ],
      [
        -989.3621826171875,
        -2650.0,
        705.541015625
      ],
      [
        -990.860595703125,
        -2650.0,
        709.5540771484375
      ],
      [
        -952.5738525390625,
        -2645.0,
        667.578125
      ],
      [
        -951.8910522460938,
        -2640.0,
        666.6993408203125
      ],
      [
        -995.3317260742188,
        -2660.0,
        714.0372314453125
      ],
      [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      [
        -972.317626953125,
        -2656.699462890625,
        757.0
      ],
      [
        -972.0087280273438,
        -2660.0,
        672.4444580078125
      ],
      [
        -990.8366088867188,
        -2660.0,
        701.9979858398438
      ],
      [
        -990.8366088867188,
        -2660.0,
        701.9979858398438
      ],
      [
        -995.3317260742188,
        -2660.0,
        714.0372314453125
      ],
      [
        -972.3176879882812,
        -2656.699462890625,
        757.0
      ],
      [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      [
        -973.61962890625,
        -2660.0,
        757.0
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -953.8565673828125,
        -2660.0,
        779.0304565429688
      ],
      [
        -932.0,
        -2660.0,
        779.0304565429688
      ],
      [
        -940.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -934.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2642.0,
        772.6678466796875
      ],
      [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -934.0,
        -2648.0,
        774.7887573242188
      ],
      [
        -990.6513061523438,
        -2710.0,
        760.0
      ],
      [
        -1001.029541015625,
        -2710.0,
        748.4310302734375
      ],
      [
        -990.4483642578125,
        -2712.0,
        760.0
      ],
      [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      [
        -989.791748046875,
        -2710.0,
        760.0
      ],
      [
        -990.0,
        -2710.0,
        759.7678833007812
      ],
      [
        -1000.169921875,
        -2710.0,
        748.4310302734375
      ],
      [
        -990.0,
        -2710.0,
        759.7678833007812
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.468505859375
      ],
      [
        -970.0,
        -2712.0,
        780.0
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -970.0,
        -2712.0,
        782.79443359375
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -970.0,
        -2712.0,
        760.0
      ],
      [
        -957.3062744140625,
        -2712.0,
        795.4685668945312
      ],
      [
        -957.2279663085938,
        -2710.0,
        795.0206909179688
      ],
      [
        -964.7109375,
        -2710.0,
        787.9583129882812
      ],
      [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      [
        -873.5,
        -2712.0,
        695.5555419921875
      ],
      [
        -863.1127319335938,
        -2762.5,
        718.0
      ],
      [
        -873.5,
        -2762.5,
        718.0
      ],
      [
        -871.5,
        -2830.819580078125,
        748.3642578125
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -871.5,
        -2762.5,
        718.0
      ],
      [
        -871.5,
        -2781.199951171875,
        720.0
      ],
      [
        -873.5,
        -2775.0,
        723.5553588867188
      ],
      [
        -871.5,
        -2781.199951171875,
        726.3109130859375
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -871.5,
        -2859.5,
        792.4702758789062
      ],
      [
        -871.5,
        -2788.75,
        784.2052612304688
      ],
      [
        -873.5,
        -2788.75,
        786.5337524414062
      ],
      [
        -873.5,
        -2775.0,
        784.927490234375
      ],
      [
        -871.5,
        -2781.199951171875,
        792.0
      ],
      [
        -871.5,
        -2781.199951171875,
        783.3233032226562
      ],
      [
        -873.5,
        -2859.5,
        795.2313232421875
      ],
      [
        -873.5,
        -2854.677490234375,
        794.2353515625
      ],
      [
        -873.5,
        -2747.351318359375,
        776.0315551757812
      ],
      [
        -871.5,
        -2751.4150390625,
        774.7340087890625
      ],
      [
        -871.5,
        -2712.0,
        760.906494140625
      ],
      [
        -872.3709106445312,
        -2712.0,
        762.0923461914062
      ],
      [
        -873.5,
        -2715.5,
        764.8575439453125
      ],
      [
        -871.5,
        -2781.199951171875,
        782.2899780273438
      ],
      [
        -871.5,
        -2751.4150390625,
        774.7340087890625
      ],
      [
        -873.5,
        -2747.351318359375,
        776.0315551757812
      ],
      [
        -873.5,
        -2775.000244140625,
        783.045654296875
      ],
      [
        -873.5,
        -2735.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        721.0
      ],
      [
        -871.5,
        -2713.5,
        720.0
      ],
      [
        -872.3709106445312,
        -2712.0,
        720.0
      ],
      [
        -871.5,
        -2712.0,
        720.0
      ],
      [
        -873.5,
        -2754.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        735.0
      ],
      [
        -873.5,
        -2735.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        721.0
      ],
      [
        -873.5,
        -2754.5,
        735.0
      ],
      [
        -871.5,
        -2859.5,
        784.7289428710938
      ],
      [
        -873.5,
        -2859.5,
        778.097412109375
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -871.5,
        -2841.150634765625,
        763.2430419921875
      ],
      [
        -871.5,
        -2841.150634765625,
        763.2430419921875
      ],
      [
        -873.5,
        -2846.85400390625,
        763.2899169921875
      ],
      [
        -873.5,
        -2839.021728515625,
        752.0096435546875
      ],
      [
        -871.5,
        -2830.819580078125,
        748.3642578125
      ],
      [
        -873.5,
        -2788.75,
        786.5337524414062
      ],
      [
        -871.5,
        -2788.75,
        784.2052612304688
      ],
      [
        -873.5,
        -2712.0,
        763.6296997070312
      ],
      [
        -873.5,
        -2712.0,
        720.0
      ],
      [
        -817.5686645507812,
        -2753.0,
        721.0
      ],
      [
        -817.5686645507812,
        -2753.0,
        732.2177124023438
      ],
      [
        -817.5686645507812,
        -2753.0,
        721.0
      ],
      [
        -806.8783569335938,
        -2737.0,
        721.0
      ],
      [
        -806.8783569335938,
        -2737.0,
        721.0
      ],
      [
        -806.8783569335938,
        -2737.0,
        740.0
      ],
      [
        -847.314208984375,
        -2732.09912109375,
        730.0
      ],
      [
        -835.5,
        -2737.0,
        718.0
      ],
      [
        -835.5,
        -2737.0,
        718.75
      ],
      [
        -835.5,
        -2737.0,
        744.0
      ],
      [
        -835.5,
        -2737.0,
        740.5
      ],
      [
        -835.5,
        -2737.0,
        740.5
      ],
      [
        -835.5,
        -2737.0,
        718.75
      ],
      [
        -852.404296875,
        -2735.5,
        744.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        744.0
      ],
      [
        -852.404296875,
        -2735.5,
        744.0
      ],
      [
        -853.0,
        -2735.89794921875,
        744.0
      ],
      [
        -853.0,
        -2737.0,
        744.0
      ],
      [
        -835.5,
        -2737.0,
        744.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        730.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        744.0
      ],
      [
        -848.6627197265625,
        -2733.000244140625,
        730.0
      ],
      [
        -830.288330078125,
        -2753.0,
        721.0
      ],
      [
        -814.539794921875,
        -2748.466796875,
        721.0
      ],
      [
        -847.314208984375,
        -2757.90087890625,
        730.0
      ],
      [
        -835.5,
        -2754.5,
        721.0
      ],
      [
        -835.5,
        -2737.0,
        721.0
      ],
      [
        -848.6626586914062,
        -2756.999755859375,
        744.0
      ],
      [
        -852.4041137695312,
        -2754.5,
        744.0
      ],
      [
        -853.0,
        -2754.101806640625,
        744.0
      ],
      [
        -852.4041137695312,
        -2754.5,
        744.0
      ],
      [
        -853.0,
        -2748.0,
        731.0
      ],
      [
        -853.0,
        -2753.0,
        744.0
      ],
      [
        -853.0,
        -2737.0,
        744.0
      ],
      [
        -853.0,
        -2742.0,
        731.0
      ],
      [
        -853.0,
        -2742.0,
        731.0
      ],
      [
        -853.0,
        -2748.0,
        731.0
      ],
      [
        -848.6626586914062,
        -2756.999755859375,
        730.0
      ],
      [
        -848.6626586914062,
        -2756.999755859375,
        744.0
      ],
      [
        -848.6626586914062,
        -2756.999755859375,
        730.0
      ],
      [
        -837.2710571289062,
        -2722.48828125,
        718.0
      ],
      [
        -837.2710571289062,
        -2722.48828125,
        782.5
      ],
      [
        -853.0,
        -2733.896728515625,
        730.0
      ],
      [
        -853.0,
        -2733.896728515625,
        744.0
      ],
      [
        -853.0,
        -2733.896728515625,
        730.0
      ],
      [
        -853.0,
        -2732.900634765625,
        730.0
      ],
      [
        -853.0,
        -2735.5,
        744.0
      ],
      [
        -853.0,
        -2733.896728515625,
        744.0
      ],
      [
        -853.0,
        -2735.5,
        744.0
      ],
      [
        -853.0,
        -2756.103271484375,
        730.0
      ],
      [
        -853.0,
        -2756.103271484375,
        744.0
      ],
      [
        -853.0,
        -2757.099365234375,
        730.0
      ],
      [
        -853.0,
        -2756.103271484375,
        730.0
      ],
      [
        -853.0,
        -2756.103271484375,
        744.0
      ],
      [
        -853.0,
        -2754.5,
        744.0
      ],
      [
        -853.0,
        -2754.5,
        744.0
      ],
      [
        -868.5,
        -2790.5,
        780.9169921875
      ],
      [
        -853.5,
        -2795.0,
        763.9791870117188
      ],
      [
        -860.38818359375,
        -2731.6298828125,
        764.5958862304688
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        770.93896484375
      ],
      [
        -866.22802734375,
        -2762.27197265625,
        774.974365234375
      ],
      [
        -860.38818359375,
        -2758.3701171875,
        767.7196044921875
      ],
      [
        -868.5,
        -2790.5,
        780.9169921875
      ],
      [
        -871.5,
        -2781.199951171875,
        783.3233032226562
      ],
      [
        -860.38818359375,
        -2731.6298828125,
        752.6632690429688
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        759.2459716796875
      ],
      [
        -866.22802734375,
        -2762.27197265625,
        771.3645629882812
      ],
      [
        -860.38818359375,
        -2758.3701171875,
        762.0442504882812
      ],
      [
        -853.0283203125,
        -2735.5,
        744.0
      ],
      [
        -853.4190673828125,
        -2733.9833984375,
        744.0
      ],
      [
        -853.0283203125,
        -2735.5,
        744.0
      ],
      [
        -853.0,
        -2735.60986328125,
        744.0
      ],
      [
        -853.4190673828125,
        -2733.9833984375,
        744.0
      ],
      [
        -853.0,
        -2733.896728515625,
        743.3988647460938
      ],
      [
        -854.5233764648438,
        -2794.69287109375,
        765.134765625
      ],
      [
        -864.6350708007812,
        -2791.659423828125,
        720.0
      ],
      [
        -855.1436767578125,
        -2794.5068359375,
        762.8601684570312
      ],
      [
        -862.2526245117188,
        -2784.784912109375,
        727.9044799804688
      ],
      [
        -871.5,
        -2826.99072265625,
        746.6625366210938
      ],
      [
        -866.8314208984375,
        -2791.00048828125,
        720.0
      ],
      [
        -863.8129272460938,
        -2791.906005859375,
        731.0691528320312
      ],
      [
        -862.1342163085938,
        -2792.40966796875,
        731.29296875
      ],
      [
        -859.685791015625,
        -2732.09912109375,
        730.0
      ],
      [
        -866.1742553710938,
        -2762.236083984375,
        771.2787475585938
      ],
      [
        -869.7310791015625,
        -2755.00927734375,
        773.5863647460938
      ],
      [
        -871.5,
        -2754.5,
        775.5166015625
      ],
      [
        -871.5,
        -2765.79443359375,
        778.3818359375
      ],
      [
        -871.5,
        -2765.79443359375,
        719.4642333984375
      ],
      [
        -866.5692138671875,
        -2762.5,
        718.0
      ],
      [
        -859.685791015625,
        -2757.90087890625,
        730.0
      ],
      [
        -854.5955810546875,
        -2735.5,
        744.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        744.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        744.0
      ],
      [
        -854.5957641601562,
        -2754.5,
        744.0
      ],
      [
        -854.5957641601562,
        -2754.5,
        744.0
      ],
      [
        -853.5,
        -2753.767822265625,
        744.0
      ],
      [
        -853.5,
        -2736.23193359375,
        744.0
      ],
      [
        -854.5955810546875,
        -2735.5,
        744.0
      ],
      [
        -853.5,
        -2736.23193359375,
        744.0
      ],
      [
        -853.5,
        -2753.767822265625,
        744.0
      ],
      [
        -853.0,
        -2753.433837890625,
        744.0
      ],
      [
        -853.0,
        -2736.566162109375,
        744.0
      ],
      [
        -860.94384765625,
        -2732.46142578125,
        731.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        744.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        731.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        731.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        744.0
      ],
      [
        -860.94384765625,
        -2757.53857421875,
        731.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        730.0
      ],
      [
        -858.3370361328125,
        -2733.000244140625,
        730.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        730.0
      ],
      [
        -858.3373413085938,
        -2756.999755859375,
        730.0
      ],
      [
        -853.4099731445312,
        -2734.018798828125,
        744.0
      ],
      [
        -869.0645141601562,
        -2788.75,
        781.3698120117188
      ],
      [
        -871.5,
        -2781.199951171875,
        782.2899780273438
      ],
      [
        -863.8129272460938,
        -2791.90625,
        731.0694580078125
      ],
      [
        -868.4998779296875,
        -2790.500244140625,
        730.4446411132812
      ],
      [
        -871.5,
        -2781.199951171875,
        726.3111572265625
      ],
      [
        -853.0,
        -2755.896484375,
        744.0
      ],
      [
        -865.5252685546875,
        -2799.7216796875,
        734.54296875
      ],
      [
        -970.0,
        -2788.75,
        803.5133056640625
      ],
      [
        -970.0,
        -2718.603271484375,
        785.2112426757812
      ],
      [
        -970.0,
        -2852.0,
        839.0
      ],
      [
        -970.0,
        -2844.0,
        839.0
      ],
      [
        -1012.960693359375,
        -2776.68798828125,
        760.0
      ],
      [
        -1012.9199829101562,
        -2777.22900390625,
        760.0
      ],
      [
        -970.0,
        -2844.0,
        844.0
      ],
      [
        -970.0,
        -2852.0,
        844.0
      ],
      [
        -970.0,
        -2852.0,
        844.0
      ],
      [
        -970.0,
        -2852.0,
        839.0
      ],
      [
        -970.0,
        -2844.0,
        839.0
      ],
      [
        -970.0,
        -2844.0,
        844.0
      ],
      [
        -970.0,
        -2718.603271484375,
        785.2112426757812
      ],
      [
        -970.0,
        -2712.0,
        782.79443359375
      ],
      [
        -1012.7234497070312,
        -2779.8427734375,
        760.0
      ],
      [
        -970.0,
        -2788.75,
        803.5133056640625
      ],
      [
        -970.0,
        -2818.693115234375,
        804.289794921875
      ],
      [
        -970.0,
        -2818.693115234375,
        804.289794921875
      ],
      [
        -970.0,
        -2859.5,
        810.2523193359375
      ],
      [
        -1012.0335693359375,
        -2789.0185546875,
        760.0
      ],
      [
        -977.9397583007812,
        -2857.0,
        760.0
      ],
      [
        -1012.0335693359375,
        -2789.0185546875,
        760.0
      ],
      [
        -977.939697265625,
        -2857.0,
        760.0
      ],
      [
        -970.0,
        -2857.0,
        760.0
      ],
      [
        -970.0,
        -2859.5,
        761.111083984375
      ],
      [
        -1020.0,
        -2776.0,
        735.0
      ],
      [
        -1018.5626831054688,
        -2776.0,
        760.0
      ],
      [
        -1010.058837890625,
        -2776.0,
        735.0
      ],
      [
        -1062.5,
        -2785.0,
        734.0
      ],
      [
        -1060.0,
        -2785.0,
        734.0
      ],
      [
        -1053.0,
        -2775.5,
        723.0
      ],
      [
        -1053.0,
        -2775.5,
        722.5
      ],
      [
        -1052.0,
        -2775.5,
        722.5
      ],
      [
        -1052.0,
        -2775.5,
        723.0
      ],
      [
        -1067.43505859375,
        -2774.0,
        726.107421875
      ],
      [
        -1066.1201171875,
        -2774.0,
        726.3181762695312
      ],
      [
        -1066.1202392578125,
        -2774.0,
        723.7416381835938
      ],
      [
        -1066.4940185546875,
        -2774.0,
        723.6817016601562
      ],
      [
        -1066.1201171875,
        -2774.0,
        726.3181762695312
      ],
      [
        -1066.1202392578125,
        -2774.0,
        723.7416381835938
      ],
      [
        -1067.0999755859375,
        -2775.199951171875,
        723.8137817382812
      ],
      [
        -1065.800048828125,
        -2775.199951171875,
        724.0221557617188
      ],
      [
        -1065.800048828125,
        -2776.5,
        724.2703857421875
      ],
      [
        -1065.800048828125,
        -2775.199951171875,
        724.0221557617188
      ],
      [
        -1066.35546875,
        -2775.199951171875,
        723.93310546875
      ],
      [
        -1004.9564819335938,
        -2776.0,
        720.0
      ],
      [
        -1047.0,
        -2776.0,
        734.0
      ],
      [
        -1051.0,
        -2776.0,
        734.0
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -970.0,
        -2831.384521484375,
        748.6153564453125
      ],
      [
        -990.0,
        -2774.0,
        723.111083984375
      ],
      [
        -970.0,
        -2774.0,
        723.111083984375
      ],
      [
        -990.0,
        -2776.0,
        724.000244140625
      ],
      [
        -978.9999389648438,
        -2776.0,
        724.000244140625
      ],
      [
        -1006.317138671875,
        -2776.0,
        724.0001220703125
      ],
      [
        -990.0,
        -2776.0,
        724.000244140625
      ],
      [
        -978.9999389648438,
        -2776.0,
        724.000244140625
      ],
      [
        -979.22216796875,
        -2774.0,
        723.1113891601562
      ],
      [
        -980.0,
        -2774.0,
        720.0
      ],
      [
        -970.0,
        -2774.0,
        760.0
      ],
      [
        -990.0,
        -2767.0,
        720.0
      ],
      [
        -980.0,
        -2767.0,
        720.0
      ],
      [
        -979.2222900390625,
        -2774.0,
        723.111083984375
      ],
      [
        -970.0,
        -2767.0,
        720.0
      ],
      [
        -1070.0,
        -2720.5,
        758.0
      ],
      [
        -1060.0,
        -2722.5,
        760.0
      ],
      [
        -1060.0,
        -2720.5,
        758.0
      ],
      [
        -1060.0,
        -2763.5,
        760.0
      ],
      [
        -1070.0,
        -2765.5,
        758.0
      ],
      [
        -1060.0,
        -2765.5,
        758.0
      ],
      [
        -1068.0,
        -2757.5,
        720.0
      ],
      [
        -1067.0,
        -2756.0,
        720.0
      ],
      [
        -1068.0,
        -2728.5,
        720.0
      ],
      [
        -1067.0,
        -2730.0,
        720.0
      ],
      [
        -1067.0,
        -2733.5,
        720.0
      ],
      [
        -1067.0,
        -2730.0,
        720.0
      ],
      [
        -1067.0,
        -2756.0,
        720.0
      ],
      [
        -1067.0,
        -2752.5,
        720.0
      ],
      [
        -1068.0,
        -2735.0,
        720.0
      ],
      [
        -1067.0,
        -2733.5,
        720.0
      ],
      [
        -1069.0001220703125,
        -2736.5,
        731.3333129882812
      ],
      [
        -1069.0001220703125,
        -2736.5,
        727.6666870117188
      ],
      [
        -1068.0,
        -2751.0,
        720.0
      ],
      [
        -1067.0,
        -2752.5,
        720.0
      ],
      [
        -1069.0,
        -2749.5,
        727.6666870117188
      ],
      [
        -1069.0,
        -2749.5,
        731.3333129882812
      ],
      [
        -1060.0,
        -2712.0,
        754.5
      ],
      [
        -1060.0,
        -2717.0,
        754.5
      ],
      [
        -1060.0,
        -2717.0,
        754.5
      ],
      [
        -1060.0,
        -2769.0,
        754.5
      ],
      [
        -1060.0,
        -2774.0,
        754.5
      ],
      [
        -1060.0,
        -2769.0,
        754.5
      ],
      [
        -1008.0,
        -2712.0,
        756.5
      ],
      [
        -1008.0,
        -2716.5,
        756.5
      ],
      [
        -1008.0,
        -2716.5,
        760.0
      ],
      [
        -1058.0,
        -2712.0,
        756.5
      ],
      [
        -1058.0,
        -2716.5,
        756.5
      ],
      [
        -1058.0,
        -2716.5,
        760.0
      ],
      [
        -1060.0,
        -2714.5,
        754.5
      ],
      [
        -1058.0,
        -2714.5,
        754.5
      ],
      [
        -1058.0,
        -2714.5,
        754.5
      ],
      [
        -1058.0,
        -2714.5,
        756.5
      ],
      [
        -1060.0,
        -2715.5,
        754.5
      ],
      [
        -1058.0,
        -2715.5,
        754.5
      ],
      [
        -1058.0,
        -2715.5,
        754.5
      ],
      [
        -1058.0,
        -2715.5,
        756.5
      ],
      [
        -1020.0,
        -2715.5,
        725.5
      ],
      [
        -1009.5,
        -2712.0,
        725.5
      ],
      [
        -1009.5,
        -2715.5,
        725.5
      ],
      [
        -1009.5,
        -2712.0,
        754.5
      ],
      [
        -1020.0,
        -2715.5,
        754.5
      ],
      [
        -1009.5,
        -2715.5,
        754.5
      ],
      [
        -1020.0,
        -2716.5,
        754.5
      ],
      [
        -1009.5,
        -2716.5,
        754.5
      ],
      [
        -1060.0,
        -2716.5,
        754.5
      ],
      [
        -1058.0,
        -2716.5,
        754.5
      ],
      [
        -1058.0,
        -2716.5,
        754.5
      ],
      [
        -1009.5,
        -2716.5,
        725.5
      ],
      [
        -1020.0,
        -2716.5,
        725.5
      ],
      [
        -1008.0,
        -2716.5,
        720.0
      ],
      [
        -1008.0,
        -2716.5,
        725.5
      ],
      [
        -1008.0,
        -2716.5,
        754.5
      ],
      [
        -1008.0,
        -2716.5,
        725.5
      ],
      [
        -1008.0,
        -2716.5,
        754.5
      ],
      [
        -1058.0,
        -2765.5,
        758.0
      ],
      [
        -1058.0,
        -2774.0,
        758.0
      ],
      [
        -1058.0,
        -2720.5,
        758.0
      ],
      [
        -1058.0,
        -2716.5,
        758.0
      ],
      [
        -1060.0,
        -2720.5,
        758.0
      ],
      [
        -1058.0,
        -2720.5,
        758.0
      ],
      [
        -1058.0,
        -2765.5,
        758.0
      ],
      [
        -1060.0,
        -2765.5,
        758.0
      ],
      [
        -1034.5,
        -2769.5,
        758.0
      ],
      [
        -1034.5,
        -2769.5,
        756.5
      ],
      [
        -1034.5,
        -2769.5,
        756.5
      ],
      [
        -1034.5,
        -2771.5,
        756.5
      ],
      [
        -1058.0,
        -2774.0,
        756.5
      ],
      [
        -1058.0,
        -2769.5,
        758.0
      ],
      [
        -1058.0,
        -2769.5,
        756.5
      ],
      [
        -1058.0,
        -2771.5,
        754.5
      ],
      [
        -1060.0,
        -2771.5,
        754.5
      ],
      [
        -1058.0,
        -2771.5,
        754.5
      ],
      [
        -1058.0,
        -2771.5,
        756.5
      ],
      [
        -1058.0,
        -2769.5,
        754.5
      ],
      [
        -1060.0,
        -2769.5,
        754.5
      ],
      [
        -1058.0,
        -2769.5,
        754.5
      ],
      [
        -1034.5,
        -2771.5,
        720.0
      ],
      [
        -1034.5,
        -2771.5,
        736.0
      ],
      [
        -1034.5,
        -2771.5,
        736.0
      ],
      [
        -1034.5,
        -2774.0,
        740.0
      ],
      [
        -1020.0,
        -2720.5,
        758.0
      ],
      [
        -1010.0,
        -2722.5,
        760.0
      ],
      [
        -1010.0,
        -2720.5,
        758.0
      ],
      [
        -1010.0,
        -2763.5,
        760.0
      ],
      [
        -1020.0,
        -2765.5,
        758.0
      ],
      [
        -1010.0,
        -2765.5,
        758.0
      ],
      [
        -1008.0,
        -2765.5,
        758.0
      ],
      [
        -1008.0,
        -2774.0,
        758.0
      ],
      [
        -1008.0,
        -2720.5,
        758.0
      ],
      [
        -1008.0,
        -2716.5,
        758.0
      ],
      [
        -1008.0,
        -2720.5,
        758.0
      ],
      [
        -1008.0,
        -2765.5,
        758.0
      ],
      [
        -1034.5,
        -2770.5,
        756.5
      ],
      [
        -1020.0,
        -2770.5,
        756.5
      ],
      [
        -1009.5,
        -2770.5,
        754.5
      ],
      [
        -1020.0,
        -2770.5,
        754.5
      ],
      [
        -1009.5,
        -2774.0,
        754.5
      ],
      [
        -1009.5,
        -2774.0,
        725.5
      ],
      [
        -1020.0,
        -2770.5,
        725.5
      ],
      [
        -1009.5,
        -2770.5,
        725.5
      ],
      [
        -1008.0,
        -2770.5,
        725.5
      ],
      [
        -1008.0,
        -2770.5,
        720.0
      ],
      [
        -1008.0,
        -2770.5,
        754.5
      ],
      [
        -1008.0,
        -2770.5,
        758.0
      ],
      [
        -1008.0,
        -2770.5,
        754.5
      ],
      [
        -1008.0,
        -2770.5,
        725.5
      ],
      [
        -1008.0,
        -2769.5,
        756.5
      ],
      [
        -1008.0,
        -2770.5,
        756.5
      ],
      [
        -1008.0,
        -2769.5,
        758.0
      ],
      [
        -1008.0,
        -2767.0,
        756.5
      ],
      [
        -970.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -1068.0,
        -2760.0,
        716.8889770507812
      ],
      [
        -1068.0,
        -2726.0,
        701.77783203125
      ],
      [
        -1046.5,
        -2764.0,
        718.6666870117188
      ],
      [
        -1064.0,
        -2764.0,
        718.6666870117188
      ],
      [
        -1068.0,
        -2760.0,
        716.8889770507812
      ],
      [
        -1064.0,
        -2764.0,
        718.6666870117188
      ],
      [
        -1068.0,
        -2757.5,
        715.77783203125
      ],
      [
        -1067.0,
        -2756.0,
        715.111083984375
      ],
      [
        -1067.0,
        -2756.0,
        715.111083984375
      ],
      [
        -1067.0,
        -2752.5,
        713.5555419921875
      ],
      [
        -1067.0,
        -2733.5,
        705.1111450195312
      ],
      [
        -1067.0,
        -2730.0,
        703.5555419921875
      ],
      [
        -1068.0,
        -2751.0,
        712.888916015625
      ],
      [
        -1067.0,
        -2752.5,
        713.5555419921875
      ],
      [
        -1068.0,
        -2735.0,
        705.7777099609375
      ],
      [
        -1067.0,
        -2733.5,
        705.1111450195312
      ],
      [
        -1068.0,
        -2728.5,
        702.8888549804688
      ],
      [
        -1067.0,
        -2730.0,
        703.5555419921875
      ],
      [
        -1068.0,
        -2726.0,
        701.77783203125
      ],
      [
        -1067.0,
        -2725.0,
        701.3333740234375
      ],
      [
        -1067.0,
        -2725.0,
        680.0
      ],
      [
        -1046.5,
        -2722.0,
        699.9999389648438
      ],
      [
        -1064.0,
        -2722.0,
        699.9999389648438
      ],
      [
        -1064.0,
        -2722.0,
        699.9999389648438
      ],
      [
        -894.0,
        -2712.0,
        695.5555419921875
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -894.0,
        -2767.0,
        720.0
      ],
      [
        -880.5184326171875,
        -2766.999755859375,
        720.0
      ],
      [
        -874.5,
        -2775.0,
        723.5556030273438
      ],
      [
        -873.5,
        -2775.0,
        723.5556030273438
      ],
      [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      [
        -874.5,
        -2775.0,
        723.5556030273438
      ],
      [
        -887.5,
        -2766.999755859375,
        720.0
      ],
      [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -894.0,
        -2712.0,
        790.9302978515625
      ],
      [
        -894.0,
        -2859.5,
        824.5013427734375
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2794.44287109375,
        811.0656127929688
      ],
      [
        -894.0,
        -2788.75,
        810.4005737304688
      ],
      [
        -884.5228271484375,
        -2724.954833984375,
        783.1830444335938
      ],
      [
        -873.5,
        -2719.897216796875,
        766.400146484375
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2712.0,
        720.0
      ],
      [
        -878.5,
        -2727.294921875,
        720.0
      ],
      [
        -878.5,
        -2762.8076171875,
        720.0
      ],
      [
        -874.5,
        -2715.5,
        721.0
      ],
      [
        -873.5,
        -2715.5,
        721.0
      ],
      [
        -878.5,
        -2735.5,
        720.0
      ],
      [
        -878.5,
        -2715.5,
        720.0
      ],
      [
        -878.5,
        -2754.5,
        720.0
      ],
      [
        -878.5,
        -2775.0,
        723.5556030273438
      ],
      [
        -932.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -932.0,
        -2712.0,
        795.468505859375
      ],
      [
        -914.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        790.9854736328125
      ],
      [
        -914.0,
        -2788.75,
        794.9854736328125
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2859.5,
        832.5732421875
      ],
      [
        -932.0,
        -2854.642578125,
        831.205810546875
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -932.0,
        -2836.284423828125,
        826.0377197265625
      ],
      [
        -932.0,
        -2788.75,
        812.65625
      ],
      [
        -928.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -918.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -918.0,
        -2853.0,
        830.743408203125
      ],
      [
        -918.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -928.0,
        -2853.0,
        830.743408203125
      ],
      [
        -918.0,
        -2853.0,
        830.743408203125
      ],
      [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -927.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -932.0,
        -2852.0,
        839.0
      ],
      [
        -932.0,
        -2844.0,
        839.0
      ],
      [
        -928.0,
        -2843.0,
        827.9282836914062
      ],
      [
        -928.0,
        -2853.0,
        830.743408203125
      ],
      [
        -932.0,
        -2844.0,
        844.0
      ],
      [
        -932.0,
        -2852.0,
        844.0
      ],
      [
        -932.0,
        -2844.0,
        839.0
      ],
      [
        -932.0,
        -2844.0,
        844.0
      ],
      [
        -932.0,
        -2852.0,
        844.0
      ],
      [
        -932.0,
        -2852.0,
        839.0
      ],
      [
        -927.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -919.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -919.0,
        -2844.0,
        828.2097778320312
      ],
      [
        -919.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -919.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      [
        -912.193115234375,
        -2930.0,
        845.7208251953125
      ],
      [
        -944.0224609375,
        -2978.0,
        801.9602661132812
      ],
      [
        -912.0682983398438,
        -2978.0,
        802.6903076171875
      ],
      [
        -906.3569946289062,
        -2978.0,
        802.6903076171875
      ],
      [
        -912.0682983398438,
        -2978.0,
        802.6903076171875
      ],
      [
        -906.3569946289062,
        -2978.0,
        802.6903076171875
      ],
      [
        -905.461181640625,
        -2930.0,
        791.174072265625
      ],
      [
        -906.232177734375,
        -2978.0,
        802.8236694335938
      ],
      [
        -954.572998046875,
        -2978.0,
        817.5613403320312
      ],
      [
        -956.2754516601562,
        -2978.0,
        817.5243530273438
      ],
      [
        -891.4109497070312,
        -2978.0,
        816.8317260742188
      ],
      [
        -893.0887451171875,
        -2978.0,
        816.8629150390625
      ],
      [
        -944.0224609375,
        -2978.0,
        801.9602661132812
      ],
      [
        -954.572998046875,
        -2978.0,
        817.5613403320312
      ],
      [
        -893.0887451171875,
        -2978.0,
        816.8629150390625
      ],
      [
        -891.4109497070312,
        -2978.0,
        816.8317260742188
      ],
      [
        -890.2421875,
        -2930.0,
        794.1980590820312
      ],
      [
        -890.8115234375,
        -2978.0,
        818.9484252929688
      ],
      [
        -956.2754516601562,
        -2978.0,
        817.5243530273438
      ],
      [
        -957.1927490234375,
        -2978.0,
        820.763671875
      ],
      [
        -890.463623046875,
        -2978.0,
        820.1769409179688
      ],
      [
        -890.463623046875,
        -2978.0,
        820.1769409179688
      ],
      [
        -892.9408569335938,
        -2978.0,
        838.7080078125
      ],
      [
        -892.9408569335938,
        -2978.0,
        838.7080078125
      ],
      [
        -893.0785522460938,
        -2978.0,
        841.7567138671875
      ],
      [
        -893.3917846679688,
        -2978.0,
        842.0807495117188
      ],
      [
        -893.377685546875,
        -2978.0,
        842.0687866210938
      ],
      [
        -893.0785522460938,
        -2978.0,
        841.7567138671875
      ],
      [
        -893.377685546875,
        -2978.0,
        842.0687866210938
      ],
      [
        -957.2632446289062,
        -2978.0,
        836.5609130859375
      ],
      [
        -957.1927490234375,
        -2978.0,
        820.763671875
      ],
      [
        -957.5886840820312,
        -2978.0,
        841.4196166992188
      ],
      [
        -957.2632446289062,
        -2978.0,
        836.5609130859375
      ],
      [
        -957.5886840820312,
        -2978.0,
        841.4196166992188
      ],
      [
        -957.2863159179688,
        -2978.0,
        841.7111206054688
      ],
      [
        -914.2279052734375,
        -2978.0,
        859.777587890625
      ],
      [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      [
        -914.2279052734375,
        -2978.0,
        859.777587890625
      ],
      [
        -934.7142944335938,
        -2978.0,
        859.526611328125
      ],
      [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      [
        -934.7142944335938,
        -2978.0,
        859.526611328125
      ],
      [
        -890.670654296875,
        -2978.0,
        819.4458618164062
      ],
      [
        -909.0738525390625,
        -2978.0,
        802.6903076171875
      ],
      [
        -890.571044921875,
        -2978.0,
        820.9805908203125
      ],
      [
        -945.1990356445312,
        -2978.0,
        803.7000732421875
      ],
      [
        -947.5514526367188,
        -3064.882080078125,
        813.04150390625
      ],
      [
        -946.9003295898438,
        -2996.380126953125,
        807.3554077148438
      ],
      [
        -946.2025146484375,
        -2978.0,
        805.1838989257812
      ],
      [
        -946.6009521484375,
        -2990.2333984375,
        806.8392333984375
      ],
      [
        -946.6377563476562,
        -2978.0,
        805.8275146484375
      ],
      [
        -946.6009521484375,
        -2990.2333984375,
        806.8392333984375
      ],
      [
        -946.9003295898438,
        -2996.380126953125,
        807.3554077148438
      ],
      [
        -891.6134033203125,
        -2978.0,
        828.7779541015625
      ],
      [
        -955.98681640625,
        -2978.0,
        817.5306396484375
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.6149458289146423,
        0.787019670009613,
        0.04941307380795479
      ],
      "plane_d": 3512.108154296875,
      "bbox_min": [
        -1267.1397705078125,
        -3646.800048828125,
        832.1895751953125
      ],
      "bbox_max": [
        -1127.2415771484375,
        -3530.23779296875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6140355467796326,
        0.7874341607093811,
        0.05392313003540039
      ],
      "plane_d": 3507.92138671875,
      "bbox_min": [
        -1267.1397705078125,
        -3646.800048828125,
        832.1895751953125
      ],
      "bbox_max": [
        -1127.2415771484375,
        -3530.23779296875,
        1035.9180908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4271385669708252,
        -0.9028797149658203,
        0.04858982190489769
      ],
      "plane_d": -2246.743408203125,
      "bbox_min": [
        -799.3662109375,
        -2218.885986328125,
        466.048828125
      ],
      "bbox_max": [
        -468.130615234375,
        -2032.99267578125,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -674.18994140625,
        -2180.648681640625,
        639.28125
      ],
      "bbox_max": [
        -468.130615234375,
        -2032.99267578125,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -674.18994140625,
        -2180.648681640625,
        639.28125
      ],
      "bbox_max": [
        -511.7373046875,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4396458864212036,
        -0.8734606504440308,
        0.20923222601413727
      ],
      "plane_d": -2314.2626953125,
      "bbox_min": [
        -674.18994140625,
        -2218.885986328125,
        559.9291381835938
      ],
      "bbox_max": [
        -577.8391723632812,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -674.18994140625,
        -2195.300048828125,
        639.2813110351562
      ],
      "bbox_max": [
        -577.8391723632812,
        -2128.6962890625,
        757.6525268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -602.43359375,
        -2193.9814453125,
        641.6248779296875
      ],
      "bbox_max": [
        -599.2575073242188,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -599.7045288085938,
        -2194.46533203125,
        641.6248779296875
      ],
      "bbox_max": [
        -598.7432250976562,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -615.3544921875,
        -2205.376953125,
        641.6248779296875
      ],
      "bbox_max": [
        -598.18994140625,
        -2192.60791015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -629.2466430664062,
        -2215.376708984375,
        639.2813110351562
      ],
      "bbox_max": [
        -603.455810546875,
        -2201.833251953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -622.4407958984375,
        -2212.70849609375,
        639.2813110351562
      ],
      "bbox_max": [
        -612.2088012695312,
        -2205.376953125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2074883133172989,
        0.8826481699943542,
        0.42175933718681335
      ],
      "plane_d": 2287.469970703125,
      "bbox_min": [
        -1216.4732666015625,
        -3470.2734375,
        812.7454833984375
      ],
      "bbox_max": [
        -704.468994140625,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1134.300048828125,
        -3470.2734375,
        819.1798095703125
      ],
      "bbox_max": [
        -773.760498046875,
        -3199.98388671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30657777190208435,
        0.701846182346344,
        0.6429790258407593
      ],
      "plane_d": 1450.49169921875,
      "bbox_min": [
        -1123.0411376953125,
        -3385.130859375,
        819.1798095703125
      ],
      "bbox_max": [
        -773.760498046875,
        -3199.98388671875,
        974.5758056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24717621505260468,
        0.11013562232255936,
        0.9626911282539368
      ],
      "plane_d": -219.55609130859375,
      "bbox_min": [
        -1123.0411376953125,
        -3385.130859375,
        819.1798095703125
      ],
      "bbox_max": [
        -876.41455078125,
        -3199.98388671875,
        903.68408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09315899014472961,
        0.1335732340812683,
        0.9866505861282349
      ],
      "plane_d": -316.9273681640625,
      "bbox_min": [
        -1134.300048828125,
        -3323.10009765625,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3231.95166015625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9190670251846313,
        -0.001398043823428452,
        0.39409878849983215
      ],
      "plane_d": 600.4259643554688,
      "bbox_min": [
        -1216.4732666015625,
        -3254.84521484375,
        812.7454833984375
      ],
      "bbox_max": [
        -845.512451171875,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09315899014472961,
        0.1335732340812683,
        0.9866505861282349
      ],
      "plane_d": -316.9273681640625,
      "bbox_min": [
        -1067.8572998046875,
        -3254.84521484375,
        852.3694458007812
      ],
      "bbox_max": [
        -1023.68017578125,
        -3209.46337890625,
        862.6844482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23609928786754608,
        0.3740059733390808,
        0.896870493888855
      ],
      "plane_d": 210.2269287109375,
      "bbox_min": [
        -1030.471435546875,
        -3242.22021484375,
        812.7454833984375
      ],
      "bbox_max": [
        -845.512451171875,
        -3057.78173828125,
        868.7452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0647813007235527,
        0.2180229127407074,
        0.9737911820411682
      ],
      "plane_d": -61.163818359375,
      "bbox_min": [
        -1030.471435546875,
        -3242.22021484375,
        812.7454833984375
      ],
      "bbox_max": [
        -892.0865478515625,
        -3057.78173828125,
        868.7452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5448715090751648,
        -0.06585269421339035,
        0.8359296917915344
      ],
      "plane_d": -366.09857177734375,
      "bbox_min": [
        -1030.471435546875,
        -3242.22021484375,
        812.7454833984375
      ],
      "bbox_max": [
        -892.0865478515625,
        -3057.78173828125,
        868.7452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -949.54150390625,
        -3071.92578125,
        812.885009765625
      ],
      "bbox_max": [
        -945.7866821289062,
        -3064.459228515625,
        815.4678955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021621091291308403,
        0.10562144964933395,
        0.9941713809967041
      ],
      "plane_d": -504.9111633300781,
      "bbox_min": [
        -947.618408203125,
        -3071.92578125,
        812.885009765625
      ],
      "bbox_max": [
        -945.7866821289062,
        -3064.909423828125,
        813.6261596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1376151144504547,
        0.1973152607679367,
        0.9706331491470337
      ],
      "plane_d": -53.18804931640625,
      "bbox_min": [
        -1025.7139892578125,
        -3242.22021484375,
        812.7454833984375
      ],
      "bbox_max": [
        -892.0865478515625,
        -3063.33447265625,
        856.9961547851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09315899014472961,
        0.1335732340812683,
        0.9866505861282349
      ],
      "plane_d": -316.9273681640625,
      "bbox_min": [
        -1025.7139892578125,
        -3242.22021484375,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3209.46337890625,
        856.9961547851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024503104388713837,
        0.08246573805809021,
        0.9962926506996155
      ],
      "plane_d": -534.0615234375,
      "bbox_min": [
        -954.8323364257812,
        -3084.55419921875,
        812.7454833984375
      ],
      "bbox_max": [
        -892.0865478515625,
        -3063.33447265625,
        824.6702270507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021621091291308403,
        0.10562144964933395,
        0.9941713809967041
      ],
      "plane_d": -504.9111633300781,
      "bbox_min": [
        -947.618408203125,
        -3071.92578125,
        812.95751953125
      ],
      "bbox_max": [
        -944.3916015625,
        -3065.25732421875,
        813.6261596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -954.8323364257812,
        -3084.55419921875,
        812.7454833984375
      ],
      "bbox_max": [
        -892.0865478515625,
        -3063.33447265625,
        824.6702270507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -954.8323364257812,
        -3071.92578125,
        813.6261596679688
      ],
      "bbox_max": [
        -947.618408203125,
        -3063.33447265625,
        821.918701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004718358162790537,
        0.006487742997705936,
        0.9999678134918213
      ],
      "plane_d": -620.764404296875,
      "bbox_min": [
        -852.0359497070312,
        -2454.57861328125,
        639.4241333007812
      ],
      "bbox_max": [
        -717.3270263671875,
        -2314.962646484375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.4241333007812
      ],
      "bbox_max": [
        -719.9760131835938,
        -2325.25537109375,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -852.0359497070312,
        -2454.57861328125,
        639.4368896484375
      ],
      "bbox_max": [
        -717.3270263671875,
        -2314.962646484375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -837.3421630859375,
        -2446.04833984375,
        687.1875
      ],
      "bbox_max": [
        -802.5704345703125,
        -2410.9833984375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734040975570679,
        0.43424248695373535,
        -0.5982979536056519
      ],
      "plane_d": 930.3226318359375,
      "bbox_min": [
        -806.7801513671875,
        -2445.98828125,
        687.498779296875
      ],
      "bbox_max": [
        -802.5712890625,
        -2439.76171875,
        687.719482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -837.3421630859375,
        -2446.04833984375,
        687.1875
      ],
      "bbox_max": [
        -802.7054443359375,
        -2410.9833984375,
        687.8262939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734040975570679,
        0.43424248695373535,
        -0.5982979536056519
      ],
      "plane_d": 930.3226318359375,
      "bbox_min": [
        -806.7734985351562,
        -2446.04833984375,
        687.5000610351562
      ],
      "bbox_max": [
        -802.7054443359375,
        -2439.968017578125,
        687.7094116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262522339820862,
        0.08588957786560059
      ],
      "plane_d": -911.859375,
      "bbox_min": [
        -837.259033203125,
        -2400.9833984375,
        663.75
      ],
      "bbox_max": [
        -768.3580932617188,
        -2314.962646484375,
        674.0292358398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -852.0359497070312,
        -2454.57861328125,
        639.4368896484375
      ],
      "bbox_max": [
        -717.3270263671875,
        -2315.40869140625,
        687.5380249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -837.3992309570312,
        -2446.15771484375,
        687.1875
      ],
      "bbox_max": [
        -796.634033203125,
        -2410.9833984375,
        687.5380249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015236764214932919,
        -0.025140661746263504,
        -0.9995678067207336
      ],
      "plane_d": 613.6358642578125,
      "bbox_min": [
        -804.6386108398438,
        -2439.760498046875,
        687.1875
      ],
      "bbox_max": [
        -796.634033203125,
        -2430.9833984375,
        687.498779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -837.3992309570312,
        -2446.15771484375,
        687.1875
      ],
      "bbox_max": [
        -796.634033203125,
        -2410.9833984375,
        687.5380249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734040975570679,
        0.43424248695373535,
        -0.5982979536056519
      ],
      "plane_d": 930.3226318359375,
      "bbox_min": [
        -806.6600952148438,
        -2446.15771484375,
        687.1875
      ],
      "bbox_max": [
        -796.634033203125,
        -2430.9833984375,
        687.5380249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -852.0359497070312,
        -2454.57861328125,
        639.4368896484375
      ],
      "bbox_max": [
        -717.3270263671875,
        -2316.99072265625,
        687.2360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7599779963493347,
        0.5533286333084106,
        0.34097036719322205
      ],
      "plane_d": 529.8473510742188,
      "bbox_min": [
        -852.0359497070312,
        -2454.57861328125,
        640.3125
      ],
      "bbox_max": [
        -717.3270263671875,
        -2358.969482421875,
        687.2360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.794124960899353,
        0.5035092234611511,
        0.3403586447238922
      ],
      "plane_d": 381.9332275390625,
      "bbox_min": [
        -799.2250366210938,
        -2454.57861328125,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2435.9833984375,
        664.99462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7906190752983093,
        0.49548137187957764,
        0.3597496747970581
      ],
      "plane_d": 352.2090148925781,
      "bbox_min": [
        -791.960205078125,
        -2454.57861328125,
        660.1710815429688
      ],
      "bbox_max": [
        -782.259033203125,
        -2440.9833984375,
        664.1784057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6407753825187683,
        0.3764681816101074,
        -0.6690878868103027
      ],
      "plane_d": 861.8073120117188,
      "bbox_min": [
        -790.6756591796875,
        -2454.57861328125,
        663.75
      ],
      "bbox_max": [
        -782.259033203125,
        -2440.9833984375,
        664.1784057617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -799.2250366210938,
        -2454.547607421875,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2435.9833984375,
        664.99462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6407753825187683,
        0.3764681816101074,
        -0.6690878868103027
      ],
      "plane_d": 861.8073120117188,
      "bbox_min": [
        -791.3250732421875,
        -2454.547607421875,
        663.75
      ],
      "bbox_max": [
        -782.259033203125,
        -2440.9833984375,
        664.99462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -852.0359497070312,
        -2454.202392578125,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2400.9833984375,
        687.2360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.675027072429657,
        -0.49037832021713257,
        -0.5512418150901794
      ],
      "plane_d": -246.33090209960938,
      "bbox_min": [
        -852.0359497070312,
        -2454.202392578125,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2400.9833984375,
        687.2360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -852.0359497070312,
        -2454.202392578125,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2400.9833984375,
        687.2360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734040975570679,
        0.43424248695373535,
        -0.5982979536056519
      ],
      "plane_d": 930.3226318359375,
      "bbox_min": [
        -846.2428588867188,
        -2454.202392578125,
        640.3125
      ],
      "bbox_max": [
        -782.259033203125,
        -2405.9833984375,
        687.2360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6407753825187683,
        0.3764681816101074,
        -0.6690878868103027
      ],
      "plane_d": 861.8073120117188,
      "bbox_min": [
        -793.8185424804688,
        -2454.202392578125,
        663.75
      ],
      "bbox_max": [
        -782.259033203125,
        -2440.9833984375,
        668.1284790039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -846.2428588867188,
        -2450.001953125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2405.9833984375,
        687.2360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -841.2787475585938,
        -2450.001953125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2410.9833984375,
        687.2360229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -806.9904174804688,
        -2450.001953125,
        640.3125
      ],
      "bbox_max": [
        -789.134033203125,
        -2435.9833984375,
        640.5751342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -776.570068359375,
        -2359.314453125,
        639.28125
      ],
      "bbox_max": [
        -563.099609375,
        -2211.751953125,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262522339820862,
        0.08588957786560059
      ],
      "plane_d": -911.859375,
      "bbox_min": [
        -768.8766479492188,
        -2318.742919921875,
        641.6248779296875
      ],
      "bbox_max": [
        -753.8310546875,
        -2300.702880859375,
        675.458740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2300.75,
        641.6248779296875
      ],
      "bbox_max": [
        -753.8310546875,
        -2300.702880859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -768.8766479492188,
        -2318.742919921875,
        643.409912109375
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        675.458740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -768.8766479492188,
        -2316.99072265625,
        648.671630859375
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        675.458740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426010489463806,
        -0.3395310640335083,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -768.8766479492188,
        -2316.0947265625,
        674.0292358398438
      ],
      "bbox_max": [
        -761.55126953125,
        -2305.747802734375,
        675.458740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -767.5608520507812,
        -2359.314453125,
        639.28125
      ],
      "bbox_max": [
        -563.099609375,
        -2211.751953125,
        686.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -767.5608520507812,
        -2359.314453125,
        639.28125
      ],
      "bbox_max": [
        -622.4407958984375,
        -2211.751953125,
        686.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -767.5608520507812,
        -2316.42041015625,
        639.28125
      ],
      "bbox_max": [
        -622.4407958984375,
        -2211.751953125,
        679.4390258789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -754.3849487304688,
        -2307.2509765625,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2304.23291015625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -760.9716186523438,
        -2311.970458984375,
        641.6248779296875
      ],
      "bbox_max": [
        -752.0360107421875,
        -2302.20166015625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -762.9484252929688,
        -2320.06591796875,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2304.79736328125,
        639.4450073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003175857476890087,
        -0.008300124667584896,
        -0.9999604821205139
      ],
      "plane_d": 669.7701416015625,
      "bbox_min": [
        -767.1821899414062,
        -2359.314453125,
        639.28125
      ],
      "bbox_max": [
        -712.98974609375,
        -2304.79736328125,
        686.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -767.1821899414062,
        -2359.314453125,
        639.28125
      ],
      "bbox_max": [
        -712.98974609375,
        -2304.79736328125,
        686.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426010489463806,
        -0.3395310640335083,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -767.1821899414062,
        -2359.314453125,
        674.4885864257812
      ],
      "bbox_max": [
        -712.98974609375,
        -2309.856689453125,
        686.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6568310856819153,
        -0.5137073397636414,
        -0.551976203918457
      ],
      "plane_d": -317.09088134765625,
      "bbox_min": [
        -758.9638671875,
        -2324.30517578125,
        684.7988891601562
      ],
      "bbox_max": [
        -752.123779296875,
        -2316.721435546875,
        686.6820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7599779963493347,
        0.5533286333084106,
        0.34097036719322205
      ],
      "plane_d": 529.8473510742188,
      "bbox_min": [
        -731.4839477539062,
        -2359.314453125,
        674.4885864257812
      ],
      "bbox_max": [
        -712.98974609375,
        -2343.50244140625,
        686.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0012480999575927854,
        -0.0017941436963155866,
        -0.9999975562095642
      ],
      "plane_d": 681.8299560546875,
      "bbox_min": [
        -731.4839477539062,
        -2348.361083984375,
        686.9425659179688
      ],
      "bbox_max": [
        -726.142822265625,
        -2343.50244140625,
        686.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.007539494428783655,
        0.012942798435688019,
        0.9998877644538879
      ],
      "plane_d": -602.7625122070312,
      "bbox_min": [
        -904.4310913085938,
        -2534.931640625,
        640.5693969726562
      ],
      "bbox_max": [
        -790.6174926757812,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.00834949966520071,
        0.011480561457574368,
        0.9998992085456848
      ],
      "plane_d": -605.692626953125,
      "bbox_min": [
        -904.4310913085938,
        -2534.931640625,
        640.5693969726562
      ],
      "bbox_max": [
        -790.6174926757812,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6407753825187683,
        0.3764681816101074,
        -0.6690878868103027
      ],
      "plane_d": 861.8073120117188,
      "bbox_min": [
        -904.4310913085938,
        -2534.931640625,
        640.5693969726562
      ],
      "bbox_max": [
        -790.6174926757812,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734040975570679,
        0.43424248695373535,
        -0.5982979536056519
      ],
      "plane_d": 930.3226318359375,
      "bbox_min": [
        -863.3790283203125,
        -2534.931640625,
        665.9375
      ],
      "bbox_max": [
        -793.8185424804688,
        -2444.58642578125,
        695.9415283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7571871280670166,
        0.14177244901657104,
        -0.6376270055770874
      ],
      "plane_d": 151.26864624023438,
      "bbox_min": [
        -863.0928344726562,
        -2534.931640625,
        665.9375
      ],
      "bbox_max": [
        -833.7198486328125,
        -2512.498046875,
        695.9338989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -863.0928344726562,
        -2534.931640625,
        665.9375
      ],
      "bbox_max": [
        -833.7198486328125,
        -2512.498046875,
        695.9338989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7724054455757141,
        0.19714896380901337,
        -0.6037565469741821
      ],
      "plane_d": 255.83349609375,
      "bbox_min": [
        -842.8680419921875,
        -2534.931640625,
        665.9375
      ],
      "bbox_max": [
        -833.7198486328125,
        -2524.685546875,
        675.0084838867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188934922218323,
        0.49224644899368286,
        0.2951386272907257
      ],
      "plane_d": 363.49578857421875,
      "bbox_min": [
        -839.5821533203125,
        -2534.931640625,
        665.9375
      ],
      "bbox_max": [
        -833.7198486328125,
        -2524.685546875,
        669.04052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015236764214932919,
        -0.025140661746263504,
        -0.9995678067207336
      ],
      "plane_d": 613.6358642578125,
      "bbox_min": [
        -863.3790283203125,
        -2521.994140625,
        687.719482421875
      ],
      "bbox_max": [
        -806.7801513671875,
        -2444.58642578125,
        695.9415283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -863.3790283203125,
        -2521.994140625,
        690.078125
      ],
      "bbox_max": [
        -851.7667236328125,
        -2512.498046875,
        695.9415283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7906190752983093,
        0.49548137187957764,
        0.3597496747970581
      ],
      "plane_d": 352.2090148925781,
      "bbox_min": [
        -904.4310913085938,
        -2534.494873046875,
        640.5693969726562
      ],
      "bbox_max": [
        -790.6174926757812,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.794124960899353,
        0.5035092234611511,
        0.3403586447238922
      ],
      "plane_d": 381.9332275390625,
      "bbox_min": [
        -847.32568359375,
        -2534.494873046875,
        640.5693969726562
      ],
      "bbox_max": [
        -791.960205078125,
        -2450.52392578125,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -847.32568359375,
        -2534.494873046875,
        641.796875
      ],
      "bbox_max": [
        -833.7198486328125,
        -2519.998046875,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -847.32568359375,
        -2534.494873046875,
        641.796875
      ],
      "bbox_max": [
        -833.7198486328125,
        -2519.998046875,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188934922218323,
        0.49224644899368286,
        0.2951386272907257
      ],
      "plane_d": 363.49578857421875,
      "bbox_min": [
        -840.2496948242188,
        -2534.494873046875,
        663.588134765625
      ],
      "bbox_max": [
        -833.7198486328125,
        -2524.685546875,
        666.0324096679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.015236764214932919,
        -0.025140661746263504,
        -0.9995678067207336
      ],
      "plane_d": 613.6358642578125,
      "bbox_min": [
        -904.4310913085938,
        -2530.37744140625,
        640.658935546875
      ],
      "bbox_max": [
        -809.40966796875,
        -2421.921875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016451746225357056,
        -0.023649385198950768,
        -0.999584972858429
      ],
      "plane_d": 616.3050537109375,
      "bbox_min": [
        -888.3395385742188,
        -2521.842041015625,
        687.7288208007812
      ],
      "bbox_max": [
        -811.7867431640625,
        -2429.94140625,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -888.3395385742188,
        -2521.842041015625,
        690.078125
      ],
      "bbox_max": [
        -851.7667236328125,
        -2496.873046875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -888.3395385742188,
        -2513.1845703125,
        690.078125
      ],
      "bbox_max": [
        -877.5479736328125,
        -2496.873046875,
        696.3748168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -888.3395385742188,
        -2510.893798828125,
        690.078125
      ],
      "bbox_max": [
        -877.5479736328125,
        -2496.873046875,
        695.8771362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -877.5479736328125,
        -2496.873046875,
        687.7759399414062
      ],
      "bbox_max": [
        -836.911376953125,
        -2429.94140625,
        690.078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6145997047424316,
        -0.3962254226207733,
        -0.682108998298645
      ],
      "plane_d": 20.72467041015625,
      "bbox_min": [
        -904.4310913085938,
        -2530.37744140625,
        640.658935546875
      ],
      "bbox_max": [
        -836.9530029296875,
        -2421.921875,
        690.536865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -904.4310913085938,
        -2508.5703125,
        665.9375
      ],
      "bbox_max": [
        -877.5479736328125,
        -2487.185546875,
        690.536865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -904.4310913085938,
        -2502.2275390625,
        665.9375
      ],
      "bbox_max": [
        -898.0948486328125,
        -2487.185546875,
        675.9594116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -904.4310913085938,
        -2500.1484375,
        665.9375
      ],
      "bbox_max": [
        -898.0948486328125,
        -2487.185546875,
        668.8807983398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7694186568260193,
        -0.5282776355743408,
        0.35905107855796814
      ],
      "plane_d": -862.0191650390625,
      "bbox_min": [
        -904.1784057617188,
        -2530.37744140625,
        640.658935546875
      ],
      "bbox_max": [
        -841.2787475585938,
        -2421.921875,
        682.542236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.675027072429657,
        -0.49037832021713257,
        -0.5512418150901794
      ],
      "plane_d": -246.33090209960938,
      "bbox_min": [
        -904.1784057617188,
        -2530.37744140625,
        641.796875
      ],
      "bbox_max": [
        -841.2787475585938,
        -2421.921875,
        682.542236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7721387147903442,
        -0.5362740755081177,
        0.34089893102645874
      ],
      "plane_d": -867.376708984375,
      "bbox_min": [
        -904.1784057617188,
        -2530.37744140625,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2421.921875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -904.1784057617188,
        -2530.37744140625,
        641.796875
      ],
      "bbox_max": [
        -841.7667236328125,
        -2487.185546875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038054414093494415,
        0.13913646340370178,
        0.98954176902771
      ],
      "plane_d": -254.50421142578125,
      "bbox_min": [
        -896.3795776367188,
        -2509.9560546875,
        641.796875
      ],
      "bbox_max": [
        -885.7332153320312,
        -2491.873046875,
        644.2561645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -896.3795776367188,
        -2504.37890625,
        641.796875
      ],
      "bbox_max": [
        -890.0479736328125,
        -2491.873046875,
        644.2561645507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -904.1784057617188,
        -2504.29541015625,
        641.796875
      ],
      "bbox_max": [
        -890.0479736328125,
        -2487.185546875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -904.1784057617188,
        -2500.811279296875,
        663.5715942382812
      ],
      "bbox_max": [
        -898.0948486328125,
        -2487.185546875,
        667.9860229492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902700662612915,
        -0.46761155128479004,
        -0.552147388458252
      ],
      "plane_d": -175.41311645507812,
      "bbox_min": [
        -941.46484375,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -941.46484375,
        -2576.886474609375,
        682.5
      ],
      "bbox_max": [
        -909.609375,
        -2559.375,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -918.32568359375,
        -2576.589599609375,
        717.738525390625
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.2710571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -915.2291870117188,
        -2576.589599609375,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.2710571289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -941.46484375,
        -2576.886474609375,
        682.5
      ],
      "bbox_max": [
        -909.609375,
        -2559.375,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -912.107177734375,
        -2576.886474609375,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.4923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038054414093494415,
        0.13913646340370178,
        0.98954176902771
      ],
      "plane_d": -254.50421142578125,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08756548166275024,
        0.15032073855400085,
        0.9847517609596252
      ],
      "plane_d": -179.49295043945312,
      "bbox_min": [
        -885.7332153320312,
        -2576.875,
        643.8728637695312
      ],
      "bbox_max": [
        -846.3800048828125,
        -2509.9560546875,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -869.765625,
        -2576.875,
        643.8728637695312
      ],
      "bbox_max": [
        -846.3800048828125,
        -2530.56689453125,
        652.96875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5358163714408875,
        -0.5204083919525146,
        -0.6648879051208496
      ],
      "plane_d": -370.36444091796875,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -910.4232788085938,
        -2576.947509765625,
        719.03125
      ],
      "bbox_max": [
        -909.609375,
        -2566.875,
        726.5377197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7724054455757141,
        0.19714896380901337,
        -0.6037565469741821
      ],
      "plane_d": 255.83349609375,
      "bbox_min": [
        -940.4493408203125,
        -2585.62548828125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -894.9523315429688,
        -2585.62548828125,
        682.1506958007812
      ],
      "bbox_max": [
        -860.625,
        -2571.875,
        726.3378295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622605800628662,
        -0.21425026655197144,
        -0.4589155912399292
      ],
      "plane_d": -986.1044921875,
      "bbox_min": [
        -890.2044677734375,
        -2581.53173828125,
        717.5496826171875
      ],
      "bbox_max": [
        -884.07763671875,
        -2571.875,
        726.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -890.2044677734375,
        -2580.69140625,
        719.03125
      ],
      "bbox_max": [
        -887.265625,
        -2571.875,
        726.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -894.9523315429688,
        -2585.62548828125,
        682.1506958007812
      ],
      "bbox_max": [
        -860.625,
        -2571.875,
        726.3378295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -861.900634765625,
        -2585.62548828125,
        682.1506958007812
      ],
      "bbox_max": [
        -860.625,
        -2579.375,
        684.910888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7571871280670166,
        0.14177244901657104,
        -0.6376270055770874
      ],
      "plane_d": 151.26864624023438,
      "bbox_min": [
        -940.4493408203125,
        -2585.442626953125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801541328430176,
        -0.36512237787246704,
        0.3033384680747986
      ],
      "plane_d": -319.669677734375,
      "bbox_min": [
        -940.4493408203125,
        -2585.442626953125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.01416015625,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -940.4493408203125,
        -2571.892578125,
        681.924560546875
      ],
      "bbox_max": [
        -933.75,
        -2559.375,
        684.4713745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8587960600852966,
        -0.3669477105140686,
        0.3575173616409302
      ],
      "plane_d": -379.470947265625,
      "bbox_min": [
        -938.7445068359375,
        -2585.442626953125,
        643.792724609375
      ],
      "bbox_max": [
        -838.7605590820312,
        -2500.811279296875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07835977524518967,
        -0.35017022490501404,
        -0.9334027171134949
      ],
      "plane_d": -298.9742431640625,
      "bbox_min": [
        -938.7445068359375,
        -2585.442626953125,
        645.602294921875
      ],
      "bbox_max": [
        -838.7605590820312,
        -2510.893798828125,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -910.0775756835938,
        -2579.614501953125,
        719.03125
      ],
      "bbox_max": [
        -887.265625,
        -2566.875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -910.0775756835938,
        -2577.3193359375,
        719.03125
      ],
      "bbox_max": [
        -907.9686279296875,
        -2566.875,
        726.8148803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20010554790496826,
        -0.33017414808273315,
        -0.9224656224250793
      ],
      "plane_d": -363.43182373046875,
      "bbox_min": [
        -938.7445068359375,
        -2585.442626953125,
        645.602294921875
      ],
      "bbox_max": [
        -838.7605590820312,
        -2513.1845703125,
        719.03125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188934922218323,
        0.49224644899368286,
        0.2951386272907257
      ],
      "plane_d": 363.49578857421875,
      "bbox_min": [
        -938.7445068359375,
        -2585.442626953125,
        645.602294921875
      ],
      "bbox_max": [
        -838.7605590820312,
        -2530.88037109375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -873.1616821289062,
        -2585.442626953125,
        652.96875
      ],
      "bbox_max": [
        -860.625,
        -2576.875,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -862.2821655273438,
        -2585.442626953125,
        681.1356811523438
      ],
      "bbox_max": [
        -860.625,
        -2579.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -873.1616821289062,
        -2583.89208984375,
        652.96875
      ],
      "bbox_max": [
        -869.765625,
        -2576.875,
        654.5232543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8071104884147644,
        0.4680122137069702,
        0.3599129617214203
      ],
      "plane_d": 269.00018310546875,
      "bbox_min": [
        -938.7445068359375,
        -2583.45654296875,
        645.602294921875
      ],
      "bbox_max": [
        -840.2496948242188,
        -2530.88037109375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.055350881069898605,
        0.20237666368484497,
        0.9777422547340393
      ],
      "plane_d": -68.79345703125,
      "bbox_min": [
        -938.7445068359375,
        -2583.45654296875,
        652.96875
      ],
      "bbox_max": [
        -869.765625,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -929.7709350585938,
        -2575.733154296875,
        652.96875
      ],
      "bbox_max": [
        -916.9639282226562,
        -2561.875,
        655.6619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -929.7709350585938,
        -2573.511474609375,
        652.96875
      ],
      "bbox_max": [
        -924.609375,
        -2561.875,
        655.6619262695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -938.7445068359375,
        -2573.474853515625,
        652.96875
      ],
      "bbox_max": [
        -924.609375,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -938.7445068359375,
        -2572.086181640625,
        680.2847900390625
      ],
      "bbox_max": [
        -933.75,
        -2559.375,
        682.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2640.0,
      "bbox_min": [
        -1070.0,
        -2978.0,
        654.4735717773438
      ],
      "bbox_max": [
        -795.0,
        -2571.4130859375,
        863.8005981445312
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -860.8630981445312,
        -2571.4130859375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        673.0926513671875
      ],
      "bbox_max": [
        -918.32568359375,
        -2571.4130859375,
        717.738525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -985.4205932617188,
        -2640.0,
        673.0926513671875
      ],
      "bbox_max": [
        -935.3463745117188,
        -2571.4130859375,
        705.8635864257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.090576171875,
        -2640.0,
        654.4735717773438
      ],
      "bbox_max": [
        -869.9378662109375,
        -2583.89208984375,
        666.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5975612998008728,
        -0.8018232583999634
      ],
      "plane_d": -957.3291625976562,
      "bbox_min": [
        -984.8797607421875,
        -2640.0,
        655.013916015625
      ],
      "bbox_max": [
        -860.8630981445312,
        -2572.491943359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -984.8797607421875,
        -2640.0,
        655.013916015625
      ],
      "bbox_max": [
        -860.8630981445312,
        -2572.491943359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -898.75,
        -2640.0,
        742.6649169921875
      ],
      "bbox_max": [
        -882.9166870117188,
        -2636.0,
        770.9197387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -895.7581787109375,
        -2636.0,
        770.9197387695312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13552974164485931,
        -0.6056485176086426,
        -0.7841055393218994
      ],
      "plane_d": -1114.1068115234375,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        656.8616333007812
      ],
      "bbox_max": [
        -862.83447265625,
        -2577.3193359375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -968.2777709960938,
        -2640.0,
        656.8616333007812
      ],
      "bbox_max": [
        -862.83447265625,
        -2584.02490234375,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -955.9262084960938,
        -2640.0,
        767.9290771484375
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -898.75,
        -2640.0,
        770.546875
      ],
      "bbox_max": [
        -897.95458984375,
        -2636.0,
        771.9608154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        -1070.0,
        -2978.0,
        658.0
      ],
      "bbox_max": [
        -795.0,
        -2640.0,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2930.0,
      "bbox_min": [
        -1070.0,
        -2978.0,
        658.0
      ],
      "bbox_max": [
        -795.0,
        -2640.0,
        863.8005981445312
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2859.5,
      "bbox_min": [
        -1070.0,
        -2930.0,
        658.0
      ],
      "bbox_max": [
        -795.0,
        -2640.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -1020.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -820.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -966.0363159179688,
        -2930.0,
        769.9266357421875
      ],
      "bbox_max": [
        -877.9636840820312,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -939.1234741210938,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        790.5327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7739577293395996,
        0.0,
        0.6332372426986694
      ],
      "plane_d": 226.98138427734375,
      "bbox_min": [
        -941.6363525390625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -902.3636474609375,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7739577293395996,
        0.0,
        0.6332372426986694
      ],
      "plane_d": -1200.1966552734375,
      "bbox_min": [
        -940.416259765625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -902.3636474609375,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -940.416259765625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -904.2719116210938,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.0615234375,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -904.2719116210938,
        -2920.0,
        792.4444580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -1020.0,
        -2930.0,
        761.111083984375
      ],
      "bbox_max": [
        -820.0,
        -2859.5,
        863.8005981445312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8156455159187317,
        -0.09158384799957275,
        -0.5712573528289795
      ],
      "plane_d": -519.972900390625,
      "bbox_min": [
        -932.0,
        -2895.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        843.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.2230224609375,
        -2863.125,
        790.1912231445312
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        792.1477661132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -870.625,
        -2863.125,
        790.1912231445312
      ],
      "bbox_max": [
        -869.7720336914062,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -932.0,
        -2895.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        843.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -871.8587036132812,
        -2863.125,
        790.0740966796875
      ],
      "bbox_max": [
        -869.8526611328125,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -871.8587036132812,
        -2863.125,
        791.875
      ],
      "bbox_max": [
        -870.625,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -932.0,
        -2895.0,
        761.111083984375
      ],
      "bbox_max": [
        -869.8880004882812,
        -2859.5,
        843.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2895.0,
        817.4066162109375
      ],
      "bbox_max": [
        -893.0647583007812,
        -2859.5,
        834.6638793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7111465930938721,
        -0.03083941340446472,
        -0.7023670673370361
      ],
      "plane_d": -142.72918701171875,
      "bbox_min": [
        -899.5184326171875,
        -2895.0,
        827.7918701171875
      ],
      "bbox_max": [
        -893.0647583007812,
        -2880.787841796875,
        834.6638793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2895.0,
        821.4066162109375
      ],
      "bbox_max": [
        -894.892822265625,
        -2859.5,
        838.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -932.0,
        -2863.125,
        832.5732421875
      ],
      "bbox_max": [
        -914.0,
        -2859.5,
        833.59375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7111465930938721,
        -0.03083941340446472,
        -0.7023670673370361
      ],
      "plane_d": -142.72918701171875,
      "bbox_min": [
        -914.0,
        -2895.0,
        829.3564453125
      ],
      "bbox_max": [
        -894.892822265625,
        -2859.5,
        838.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -914.0,
        -2863.125,
        832.5732421875
      ],
      "bbox_max": [
        -899.6533813476562,
        -2859.5,
        833.59375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -879.7694091796875,
        -2864.73291015625,
        761.111083984375
      ],
      "bbox_max": [
        -869.8880004882812,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188836812973022,
        0.3240675628185272,
        0.22501777112483978
      ],
      "plane_d": -51.82562255859375,
      "bbox_min": [
        -879.7694091796875,
        -2864.73291015625,
        761.111083984375
      ],
      "bbox_max": [
        -877.9344482421875,
        -2859.5,
        763.4368286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920820951461792,
        0.2899842858314514,
        0.26076391339302063
      ],
      "plane_d": -177.9209442138672,
      "bbox_min": [
        -895.5677490234375,
        -2895.0,
        791.0235595703125
      ],
      "bbox_max": [
        -870.625,
        -2863.125,
        830.6638793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7111465930938721,
        -0.03083941340446472,
        -0.7023670673370361
      ],
      "plane_d": -142.72918701171875,
      "bbox_min": [
        -895.5677490234375,
        -2895.0,
        825.9469604492188
      ],
      "bbox_max": [
        -890.9091186523438,
        -2887.3095703125,
        830.6638793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        776.8888549804688
      ],
      "bbox_max": [
        -870.965576171875,
        -2895.0,
        863.8005981445312
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7073557376861572,
        -0.10758212953805923,
        -0.6986229419708252
      ],
      "plane_d": -366.921630859375,
      "bbox_min": [
        -908.9210815429688,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6411095261573792,
        -0.19564983248710632,
        -0.7420914173126221
      ],
      "plane_d": -530.467529296875,
      "bbox_min": [
        -886.190185546875,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        823.2562255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.5282592773438,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.9566040039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -908.9210815429688,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.4671020507812,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        820.4992065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920820951461792,
        0.2899842858314514,
        0.26076391339302063
      ],
      "plane_d": -177.9209442138672,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.4382934570312,
        -2930.0,
        790.2222290039062
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        819.862548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -891.4382934570312,
        -2930.0,
        790.2222290039062
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        819.862548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -883.3820190429688,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -882.5,
        -2925.0,
        819.862548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -932.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -932.0,
        -2930.0,
        843.216552734375
      ],
      "bbox_max": [
        -906.88134765625,
        -2920.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8156455159187317,
        -0.09158384799957275,
        -0.5712573528289795
      ],
      "plane_d": -519.972900390625,
      "bbox_min": [
        -883.9014892578125,
        -2925.0,
        816.5783081054688
      ],
      "bbox_max": [
        -881.5404052734375,
        -2920.0,
        819.949462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -888.9662475585938,
        -2920.0,
        821.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -894.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -888.9662475585938,
        -2920.0,
        792.794677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162713289260864,
        0.28804752230644226,
        0.27834439277648926
      ],
      "plane_d": -193.42660522460938,
      "bbox_min": [
        -890.5786743164062,
        -2925.0,
        788.0
      ],
      "bbox_max": [
        -888.9662475585938,
        -2920.0,
        790.3557739257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -894.0,
        -2920.0,
        792.9425659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -901.9560546875,
        -2920.0,
        792.9763793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -903.77392578125,
        -2920.0,
        792.9763793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7111465930938721,
        -0.03083941340446472,
        -0.7023670673370361
      ],
      "plane_d": -142.72918701171875,
      "bbox_min": [
        -932.0,
        -2920.0,
        776.8888549804688
      ],
      "bbox_max": [
        -876.742431640625,
        -2895.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920820951461792,
        0.2899842858314514,
        0.26076391339302063
      ],
      "plane_d": -177.9209442138672,
      "bbox_min": [
        -932.0,
        -2920.0,
        776.8888549804688
      ],
      "bbox_max": [
        -876.742431640625,
        -2895.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -932.0,
        -2920.0,
        776.8888549804688
      ],
      "bbox_max": [
        -876.742431640625,
        -2895.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2920.0,
        838.9867553710938
      ],
      "bbox_max": [
        -914.0,
        -2895.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2920.0,
        842.5675659179688
      ],
      "bbox_max": [
        -914.0,
        -2916.164306640625,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8156455159187317,
        -0.09158384799957275,
        -0.5712573528289795
      ],
      "plane_d": -519.972900390625,
      "bbox_min": [
        -932.0,
        -2920.0,
        776.8888549804688
      ],
      "bbox_max": [
        -876.742431640625,
        -2895.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2920.0,
        776.8888549804688
      ],
      "bbox_max": [
        -880.9041748046875,
        -2895.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2920.0,
        830.6638793945312
      ],
      "bbox_max": [
        -914.0,
        -2895.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2920.0,
        830.6638793945312
      ],
      "bbox_max": [
        -914.0,
        -2895.0,
        843.216552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2916.164306640625,
        834.6638793945312
      ],
      "bbox_max": [
        -914.0,
        -2895.0,
        842.5675659179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162713289260864,
        0.28804752230644226,
        0.27834439277648926
      ],
      "plane_d": -193.42660522460938,
      "bbox_min": [
        -889.681884765625,
        -2920.0,
        776.8888549804688
      ],
      "bbox_max": [
        -880.9041748046875,
        -2895.0,
        791.0235595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7959103584289551,
        0.01854807510972023,
        -0.6051303148269653
      ],
      "plane_d": 1315.767333984375,
      "bbox_min": [
        -985.7762451171875,
        -2895.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        838.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -985.7762451171875,
        -2863.125,
        790.23095703125
      ],
      "bbox_max": [
        -984.375,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -985.7762451171875,
        -2863.125,
        790.45849609375
      ],
      "bbox_max": [
        -984.375,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -985.7095336914062,
        -2895.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        838.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -985.7095336914062,
        -2863.125,
        789.768310546875
      ],
      "bbox_max": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -984.927490234375,
        -2863.125,
        791.2595825195312
      ],
      "bbox_max": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8725059032440186,
        0.4155133366584778,
        0.25706446170806885
      ],
      "plane_d": 1844.9765625,
      "bbox_min": [
        -985.5738525390625,
        -2895.0,
        761.111083984375
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        838.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -985.5738525390625,
        -2864.73291015625,
        761.111083984375
      ],
      "bbox_max": [
        -975.2305908203125,
        -2859.5,
        791.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8552238941192627,
        0.42890995740890503,
        0.29090940952301025
      ],
      "plane_d": 1840.6619873046875,
      "bbox_min": [
        -977.84033203125,
        -2864.73291015625,
        761.111083984375
      ],
      "bbox_max": [
        -975.2305908203125,
        -2859.5,
        763.4368286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8746123313903809,
        0.4167838394641876,
        0.2476782649755478
      ],
      "plane_d": 1858.1204833984375,
      "bbox_min": [
        -984.375,
        -2895.0,
        791.0235595703125
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        838.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.16682107746601105,
        -0.9859871864318848
      ],
      "plane_d": 344.28314208984375,
      "bbox_min": [
        -957.727294921875,
        -2895.0,
        825.9469604492188
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        838.9867553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.27098217606544495,
        -0.962584376335144
      ],
      "plane_d": 26.5484619140625,
      "bbox_min": [
        -953.0294189453125,
        -2863.125,
        832.5732421875
      ],
      "bbox_max": [
        -932.0,
        -2859.5,
        833.59375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7103961706161499,
        0.055301763117313385,
        -0.7016258835792542
      ],
      "plane_d": 1419.9700927734375,
      "bbox_min": [
        -973.1060791015625,
        -2930.0,
        776.8888549804688
      ],
      "bbox_max": [
        -932.0,
        -2895.0,
        863.8005981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -973.034423828125,
        -2930.0,
        808.6144409179688
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        863.8005981445312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -935.4811401367188,
        -2925.0,
        845.7122802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902596354484558,
        -0.23094093799591064,
        -0.685716986656189
      ],
      "plane_d": 550.4041748046875,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -937.5,
        -2925.0,
        845.6749267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -961.9822998046875,
        -2925.0,
        820.943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -962.5,
        -2930.0,
        818.75
      ],
      "bbox_max": [
        -961.9822998046875,
        -2925.0,
        818.93994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8746123313903809,
        0.4167838394641876,
        0.2476782649755478
      ],
      "plane_d": 1858.1204833984375,
      "bbox_min": [
        -973.1060791015625,
        -2930.0,
        776.8888549804688
      ],
      "bbox_max": [
        -932.0,
        -2895.0,
        850.0252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -972.8995361328125,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -952.7792358398438,
        -2920.0,
        818.8798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -954.5962524414062,
        -2930.0,
        790.2222290039062
      ],
      "bbox_max": [
        -952.7792358398438,
        -2925.0,
        792.8374633789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7959103584289551,
        0.01854807510972023,
        -0.6051303148269653
      ],
      "plane_d": 1315.767333984375,
      "bbox_min": [
        -973.1060791015625,
        -2930.0,
        776.8888549804688
      ],
      "bbox_max": [
        -932.0,
        -2895.0,
        850.0252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -964.4384155273438,
        -2920.0,
        816.5784301757812
      ],
      "bbox_max": [
        -961.7053833007812,
        -2920.0,
        819.9485473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -938.7247314453125,
        -2930.0,
        843.216552734375
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        850.0252685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -937.5,
        -2930.0,
        844.0625
      ],
      "bbox_max": [
        -932.0,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -937.5,
        -2930.0,
        844.0625
      ],
      "bbox_max": [
        -935.0020141601562,
        -2925.0,
        845.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2920.0,
      "bbox_min": [
        -964.2677001953125,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        843.216552734375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        -954.4213256835938,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -954.4213256835938,
        -2930.0,
        789.6239013671875
      ],
      "bbox_max": [
        -950.0,
        -2923.65380859375,
        792.89794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -950.0,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        793.0687255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -942.1470947265625,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -940.857421875,
        -2930.0,
        788.0
      ],
      "bbox_max": [
        -938.0,
        -2920.0,
        793.0968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -938.0,
        -2930.0,
        838.0
      ],
      "bbox_max": [
        -932.0,
        -2920.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2712.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        658.0
      ],
      "bbox_max": [
        -795.0,
        -2640.0,
        860.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8908354640007019,
        0.4543260931968689
      ],
      "plane_d": 2074.13232421875,
      "bbox_min": [
        -1020.0,
        -2712.0,
        658.0
      ],
      "bbox_max": [
        -815.0,
        -2640.0,
        860.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -1020.0,
        -2712.0,
        670.0
      ],
      "bbox_max": [
        -836.0967407226562,
        -2670.0,
        752.3528442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -1020.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -970.0,
        -2674.543212890625,
        752.3527221679688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -1007.907958984375,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -970.0,
        -2674.543212890625,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -1007.907958984375,
        -2710.0,
        678.9081420898438
      ],
      "bbox_max": [
        -981.5535278320312,
        -2674.543212890625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1007.45263671875,
        -2710.0,
        694.6666870117188
      ],
      "bbox_max": [
        -996.9083251953125,
        -2700.84130859375,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -996.2919311523438,
        -2697.0,
        678.9081420898438
      ],
      "bbox_max": [
        -981.5535278320312,
        -2674.543212890625,
        694.1002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.0,
      "bbox_min": [
        -1020.0,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -971.9118041992188,
        -2695.500244140625,
        752.3527221679688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -971.9118041992188,
        -2710.0,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230917811393738,
        -0.23741567134857178,
        -0.6486693620681763
      ],
      "plane_d": 565.302490234375,
      "bbox_min": [
        -1012.0521240234375,
        -2710.0,
        720.0
      ],
      "bbox_max": [
        -1000.169921875,
        -2695.500244140625,
        748.4310913085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1012.0521240234375,
        -2710.0,
        720.0
      ],
      "bbox_max": [
        -1006.3765869140625,
        -2695.500244140625,
        735.1856079101562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -1009.0059204101562,
        -2697.0,
        720.0
      ],
      "bbox_max": [
        -1007.4884643554688,
        -2695.500244140625,
        722.940673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -894.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -836.0967407226562,
        -2674.543212890625,
        752.3528442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -853.0,
        -2712.0,
        718.0
      ],
      "bbox_max": [
        -836.0967407226562,
        -2697.099365234375,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -853.0,
        -2674.543212890625,
        752.3528442382812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -853.0,
        -2674.543212890625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -856.8702392578125,
        -2712.0,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2697.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        678.9081420898438
      ],
      "bbox_max": [
        -855.9998168945312,
        -2674.543212890625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -870.9032592773438,
        -2712.0,
        718.0
      ],
      "bbox_max": [
        -855.9998168945312,
        -2697.67041015625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -868.5,
        -2712.0,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2695.5,
        752.3527221679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -868.5,
        -2700.0,
        720.0
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        728.8235473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -856.3504028320312,
        -2697.0,
        720.0
      ],
      "bbox_max": [
        -855.4293823242188,
        -2696.22900390625,
        722.940673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -856.40234375,
        -2696.355224609375,
        720.0
      ],
      "bbox_max": [
        -855.9296264648438,
        -2695.500244140625,
        721.4287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -1020.0,
        -2712.0,
        658.0
      ],
      "bbox_max": [
        -815.0,
        -2640.0,
        860.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -2200.335693359375,
      "bbox_min": [
        -840.77197265625,
        -2712.0,
        733.2783813476562
      ],
      "bbox_max": [
        -836.0967407226562,
        -2702.27197265625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        -0.1950865238904953,
        0.0
      ],
      "plane_d": -1349.106689453125,
      "bbox_min": [
        -836.8701171875,
        -2712.0,
        744.7284545898438
      ],
      "bbox_max": [
        -836.0967407226562,
        -2708.11181640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -932.0,
      "bbox_min": [
        -1020.0,
        -2712.0,
        665.7777709960938
      ],
      "bbox_max": [
        -853.0,
        -2640.0,
        860.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -757.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -858.5,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -858.5,
        -2640.0,
        757.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -876.8843383789062,
        -2650.0,
        665.7777709960938
      ],
      "bbox_max": [
        -875.80322265625,
        -2645.0,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -875.9871215820312,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -875.6536865234375,
        -2647.400390625,
        668.4568481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.811839759349823,
        -0.18294356763362885,
        -0.5544798374176025
      ],
      "plane_d": -792.13720703125,
      "bbox_min": [
        -864.775634765625,
        -2645.0,
        705.4423217773438
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        708.57958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -863.125,
        -2645.0,
        705.4423217773438
      ],
      "bbox_max": [
        -862.9345092773438,
        -2640.0,
        707.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -863.4917602539062,
        -2645.0,
        704.4490356445312
      ],
      "bbox_max": [
        -863.1060180664062,
        -2640.0,
        707.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9181978106498718,
        0.17251762747764587,
        0.3565817177295685
      ],
      "plane_d": -588.6033935546875,
      "bbox_min": [
        -932.0,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -862.1634521484375,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -878.75,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -862.1634521484375,
        -2640.0,
        710.0059814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9335393905639648,
        0.18850381672382355,
        0.30491068959236145
      ],
      "plane_d": -525.3068237304688,
      "bbox_min": [
        -878.75,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -877.3690185546875,
        -2640.0,
        668.7150268554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -932.0,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        -932.0,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": -1116.6708984375,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        668.0
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.763513445854187,
        -0.0,
        -0.6457920074462891
      ],
      "plane_d": -200.36721801757812,
      "bbox_min": [
        -895.098388671875,
        -2650.0,
        725.420166015625
      ],
      "bbox_max": [
        -876.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -754.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        -932.0,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2660.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2650.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -863.8507690429688,
        -2660.0,
        702.353759765625
      ],
      "bbox_max": [
        -860.2403564453125,
        -2650.0,
        714.3930053710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -883.2678833007812,
        -2660.0,
        754.8399047851562
      ],
      "bbox_max": [
        -880.7991943359375,
        -2656.699462890625,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -932.0,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -882.3856201171875,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -927.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -921.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -921.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -915.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 909.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -909.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -927.0,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -882.3856201171875,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -927.0,
        -2656.699462890625,
        757.0
      ],
      "bbox_max": [
        -883.2678833007812,
        -2640.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 921.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -927.0,
      "bbox_min": [
        -927.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -921.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -927.0,
        -2642.0,
        757.0
      ],
      "bbox_max": [
        -921.0,
        -2642.0,
        772.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -915.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 909.0,
      "bbox_min": [
        -915.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -915.0,
        -2642.0,
        757.0
      ],
      "bbox_max": [
        -909.0,
        -2642.0,
        772.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7879047393798828,
        -0.21060298383235931,
        -0.5786644220352173
      ],
      "plane_d": -817.3908081054688,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        730.5894775390625
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        737.9696044921875
      ],
      "bbox_max": [
        -858.517822265625,
        -2697.00537109375,
        762.2891845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        752.6119384765625
      ],
      "bbox_max": [
        -868.5,
        -2700.0,
        762.2891845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8359991908073425,
        -0.3471871614456177,
        -0.424931138753891
      ],
      "plane_d": -1339.1102294921875,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -854.1092529296875,
        -2695.682861328125,
        730.1375732421875
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        731.485595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9562401175498962,
        -0.058091018348932266,
        0.28675806522369385
      ],
      "plane_d": -1181.9764404296875,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.125,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -855.9295043945312,
        -2696.228759765625,
        720.0
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        729.6782836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.5,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2668.288818359375,
        766.3236694335938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        -932.0,
        -2679.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2668.288818359375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2712.0,
        750.0
      ],
      "bbox_max": [
        -890.8987426757812,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        -932.0,
        -2679.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2660.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2679.0,
        750.0
      ],
      "bbox_max": [
        -914.0,
        -2660.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -898.28125,
        -2712.0,
        787.3197021484375
      ],
      "bbox_max": [
        -890.8987426757812,
        -2697.0,
        795.468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.948239803314209,
        -0.06707806885242462,
        0.31038981676101685
      ],
      "plane_d": -1215.5687255859375,
      "bbox_min": [
        -873.6409912109375,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -853.5,
        -2660.0,
        762.0924682617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -872.3709716796875,
        -2712.0,
        721.4291381835938
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        762.0924682617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        0.9578263163566589,
        0.0
      ],
      "plane_d": 2336.5693359375,
      "bbox_min": [
        -868.5,
        -2700.0,
        721.4291381835938
      ],
      "bbox_max": [
        -853.5,
        -2695.5,
        752.6119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2650.0,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        757.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        665.7777709960938
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7656795978546143,
        -0.3308616876602173,
        0.5516024231910706
      ],
      "plane_d": -508.3144226074219,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -960.0,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -957.2064208984375,
        -2640.0,
        668.449462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944882154464722,
        -0.3273007273674011,
        0.3045734167098999
      ],
      "plane_d": -210.32826232910156,
      "bbox_min": [
        -960.0,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -957.8712158203125,
        -2640.0,
        668.449462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916763782501221,
        -0.6534191370010376,
        -0.3076155185699463
      ],
      "plane_d": -826.90478515625,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6333297491073608,
        -0.5605108141899109,
        -0.5335926413536072
      ],
      "plane_d": -479.0087890625,
      "bbox_min": [
        -988.625,
        -2645.0,
        705.8635864257812
      ],
      "bbox_max": [
        -983.5679931640625,
        -2640.0,
        708.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 972.0,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -990.860595703125,
        -2650.0,
        705.541015625
      ],
      "bbox_max": [
        -988.625,
        -2645.0,
        709.5540771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7896519899368286,
        0.0,
        0.6135550141334534
      ],
      "plane_d": 342.6059265136719,
      "bbox_min": [
        -972.0,
        -2650.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -960.0,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -951.8910522460938,
        -2640.0,
        667.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.17309880256652832,
        0.9849044680595398
      ],
      "plane_d": -199.65432739257812,
      "bbox_min": [
        -952.5738525390625,
        -2645.0,
        666.6993408203125
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        667.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 748.0,
      "bbox_min": [
        -952.901611328125,
        -2650.0,
        748.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        748.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        668.0
      ],
      "bbox_max": [
        -965.4456787109375,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9062294363975525,
        -0.25349634885787964,
        0.33836036920547485
      ],
      "plane_d": -13.903305053710938,
      "bbox_min": [
        -995.3317260742188,
        -2660.0,
        701.9979858398438
      ],
      "bbox_max": [
        -972.3176879882812,
        -2650.0,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -975.557373046875,
        -2660.0,
        754.8399047851562
      ],
      "bbox_max": [
        -972.3176879882812,
        -2656.699462890625,
        757.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -972.317626953125,
        -2660.0,
        757.0
      ],
      "bbox_max": [
        -932.0,
        -2640.0,
        779.0304565429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 934.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        772.6678466796875
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2648.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        774.7887573242188
      ],
      "bbox_max": [
        -934.0,
        -2648.0,
        777.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -972.317626953125,
        -2656.699462890625,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2640.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 934.0,
      "bbox_min": [
        -940.0,
        -2648.0,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        774.7887573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2642.0,
      "bbox_min": [
        -940.0,
        -2642.0,
        757.0
      ],
      "bbox_max": [
        -934.0,
        -2642.0,
        772.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7142226696014404,
        -0.28173136711120605,
        -0.640713095664978
      ],
      "plane_d": 430.9955749511719,
      "bbox_min": [
        -1020.0,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.0,
      "bbox_min": [
        -1020.0,
        -2710.0,
        748.4310302734375
      ],
      "bbox_max": [
        -990.6513061523438,
        -2710.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.0,
      "bbox_min": [
        -1001.029541015625,
        -2710.0,
        748.4310302734375
      ],
      "bbox_max": [
        -989.791748046875,
        -2710.0,
        760.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.772372841835022,
        -0.513153076171875,
        -0.3743181824684143
      ],
      "plane_d": -328.9428405761719,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.33327484130859375,
        -0.9428297281265259
      ],
      "plane_d": -152.0179443359375,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.804488480091095,
        -0.30020061135292053,
        0.512520968914032
      ],
      "plane_d": -361.2057189941406,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        672.4444580078125
      ],
      "bbox_max": [
        -932.0,
        -2660.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        722.940673828125
      ],
      "bbox_max": [
        -932.0,
        -2697.0,
        795.4685668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.0,
      "bbox_min": [
        -1011.9400024414062,
        -2712.0,
        722.940673828125
      ],
      "bbox_max": [
        -956.71875,
        -2697.0,
        795.4685668945312
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -972.8922729492188,
        -2712.0,
        748.4310302734375
      ],
      "bbox_max": [
        -957.2279663085938,
        -2710.0,
        795.4685668945312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -972.8922729492188,
        -2712.0,
        748.4310302734375
      ],
      "bbox_max": [
        -970.0,
        -2710.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9311071038246155,
        0.11036209017038345,
        0.347648948431015
      ],
      "plane_d": 985.8095703125,
      "bbox_min": [
        -1011.9400024414062,
        -2701.77294921875,
        722.940673828125
      ],
      "bbox_max": [
        -1009.0059204101562,
        -2697.0,
        732.2994384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9310928583145142,
        0.10939528048038483,
        0.34799253940582275
      ],
      "plane_d": 982.9365844726562,
      "bbox_min": [
        -1011.9400024414062,
        -2701.77294921875,
        726.1282958984375
      ],
      "bbox_max": [
        -1010.0033569335938,
        -2697.0,
        732.2994384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -873.5,
      "bbox_min": [
        -1070.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -795.0,
        -2712.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -718.0,
      "bbox_min": [
        -873.5,
        -2859.5,
        683.0
      ],
      "bbox_max": [
        -795.0,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -873.5,
        -2762.5,
        695.5555419921875
      ],
      "bbox_max": [
        -863.1127319335938,
        -2712.0,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 871.5,
      "bbox_min": [
        -873.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -795.0,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -873.5,
        -2859.5,
        718.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        0.3070027828216553,
        0.0
      ],
      "plane_d": 2.34857177734375,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -873.5,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        795.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -873.5,
        -2781.199951171875,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        783.045654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -873.5,
        -2754.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -871.5,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -872.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2735.5,
        735.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2741.5,
      "bbox_min": [
        -872.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2748.5,
      "bbox_min": [
        -872.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -872.5,
        -2748.5,
        730.0
      ],
      "bbox_max": [
        -871.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -872.5,
        -2735.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -873.5,
        -2754.5,
        721.0
      ],
      "bbox_max": [
        -872.5,
        -2754.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -873.5,
        -2859.5,
        748.3642578125
      ],
      "bbox_max": [
        -871.5,
        -2775.000244140625,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188836812973022,
        0.3240675628185272,
        0.22501777112483978
      ],
      "plane_d": -51.82562255859375,
      "bbox_min": [
        -873.5,
        -2846.85400390625,
        748.3642578125
      ],
      "bbox_max": [
        -871.5,
        -2830.819580078125,
        763.2899169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -873.5,
        -2788.75,
        782.2899780273438
      ],
      "bbox_max": [
        -871.5,
        -2775.000244140625,
        786.5337524414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -872.3709106445312,
        -2712.0,
        764.8575439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -873.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -872.3709106445312,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 849.6354370117188,
      "bbox_min": [
        -853.0,
        -2787.72802734375,
        718.0
      ],
      "bbox_max": [
        -795.0,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2753.0,
      "bbox_min": [
        -817.5686645507812,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -817.5686645507812,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -806.8783569335938,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2737.0,
      "bbox_min": [
        -806.8783569335938,
        -2737.0,
        721.0
      ],
      "bbox_max": [
        -795.0,
        -2737.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -2763.87353515625,
      "bbox_min": [
        -853.0,
        -2781.89990234375,
        718.0
      ],
      "bbox_max": [
        -806.8783569335938,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555502772331238,
        0.8314830660820007,
        0.0
      ],
      "plane_d": 1800.968505859375,
      "bbox_min": [
        -853.0,
        -2758.3701171875,
        718.0
      ],
      "bbox_max": [
        -806.8783569335938,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2737.0,
      "bbox_min": [
        -853.0,
        -2758.3701171875,
        718.0
      ],
      "bbox_max": [
        -806.8783569335938,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2766169011592865,
        -0.9609803557395935,
        0.0
      ],
      "plane_d": -2859.875244140625,
      "bbox_min": [
        -853.0,
        -2737.0,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314489126205444,
        -0.555601179599762,
        0.0
      ],
      "plane_d": -2221.611328125,
      "bbox_min": [
        -847.314208984375,
        -2732.46142578125,
        718.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -847.314208984375,
        -2732.46142578125,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2731.6298828125,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -835.5,
      "bbox_min": [
        -853.0,
        -2737.0,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2732.09912109375,
        744.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.0,
        -2737.0,
        730.0
      ],
      "bbox_max": [
        -835.5,
        -2732.09912109375,
        744.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2504.648193359375,
      "bbox_min": [
        -848.6627197265625,
        -2733.000244140625,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2732.09912109375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -848.6627197265625,
        -2733.000244140625,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2732.09912109375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2766169011592865,
        0.9609803557395935,
        0.0
      ],
      "plane_d": 2415.906982421875,
      "bbox_min": [
        -853.0,
        -2758.3701171875,
        718.0
      ],
      "bbox_max": [
        -806.8783569335938,
        -2737.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314489126205444,
        0.555601179599762,
        0.0
      ],
      "plane_d": 828.6392211914062,
      "bbox_min": [
        -847.314208984375,
        -2758.3701171875,
        718.0
      ],
      "bbox_max": [
        -814.539794921875,
        -2748.466796875,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -830.288330078125,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -814.539794921875,
        -2748.466796875,
        732.2177124023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2753.0,
      "bbox_min": [
        -824.0,
        -2753.0,
        721.0
      ],
      "bbox_max": [
        -817.5686645507812,
        -2753.0,
        732.2177124023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -847.314208984375,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2757.53857421875,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -853.0,
        -2757.90087890625,
        718.0
      ],
      "bbox_max": [
        -806.8783569335938,
        -2737.0,
        744.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -835.5,
      "bbox_min": [
        -841.5,
        -2754.5,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2737.0,
        721.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -719.0,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -839.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -841.5,
      "bbox_min": [
        -841.5,
        -2748.5,
        718.5
      ],
      "bbox_max": [
        -841.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -839.5,
      "bbox_min": [
        -839.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -839.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -837.5,
      "bbox_min": [
        -837.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -837.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.0,
        -2757.90087890625,
        721.0
      ],
      "bbox_max": [
        -834.5,
        -2737.0,
        744.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -835.5,
      "bbox_min": [
        -853.0,
        -2757.90087890625,
        721.0
      ],
      "bbox_max": [
        -834.5,
        -2737.0,
        744.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2741.5,
      "bbox_min": [
        -835.5,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -834.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -835.5,
        -2748.5,
        730.0
      ],
      "bbox_max": [
        -834.5,
        -2741.5,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": -2302.420166015625,
      "bbox_min": [
        -853.0,
        -2757.90087890625,
        730.0
      ],
      "bbox_max": [
        -835.5,
        -2737.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": 2821.6474609375,
      "bbox_min": [
        -853.0,
        -2748.0,
        731.0
      ],
      "bbox_max": [
        -835.5,
        -2737.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -853.0,
        -2748.0,
        731.0
      ],
      "bbox_max": [
        -835.5,
        -2742.0,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        0.9793003797531128,
        -0.0
      ],
      "plane_d": 2871.710693359375,
      "bbox_min": [
        -848.6626586914062,
        -2757.90087890625,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2756.999755859375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -848.6626586914062,
        -2757.90087890625,
        730.0
      ],
      "bbox_max": [
        -846.05615234375,
        -2756.999755859375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2722.48828125,
      "bbox_min": [
        -853.0,
        -2735.89794921875,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7682725787162781,
        -0.6401229500770569,
        -0.0
      ],
      "plane_d": -2388.076171875,
      "bbox_min": [
        -840.5,
        -2722.48828125,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831483006477356,
        0.555550217628479,
        0.0
      ],
      "plane_d": 816.3023071289062,
      "bbox_min": [
        -837.2710571289062,
        -2722.48828125,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2712.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        0.1950865238904953,
        0.0
      ],
      "plane_d": -289.78680419921875,
      "bbox_min": [
        -836.8701171875,
        -2721.88818359375,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2712.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        -0.1950865238904953,
        0.0
      ],
      "plane_d": -1349.106689453125,
      "bbox_min": [
        -836.0967407226562,
        -2715.0,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2712.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831483006477356,
        0.555550217628479,
        0.0
      ],
      "plane_d": 816.3023071289062,
      "bbox_min": [
        -853.0,
        -2735.89794921875,
        718.0
      ],
      "bbox_max": [
        -837.2710571289062,
        -2722.48828125,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2504.648193359375,
      "bbox_min": [
        -853.0,
        -2735.89794921875,
        730.0
      ],
      "bbox_max": [
        -846.61181640625,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.0,
        -2735.89794921875,
        744.0
      ],
      "bbox_max": [
        -848.6627197265625,
        -2733.000244140625,
        744.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2781.89990234375,
      "bbox_min": [
        -840.5,
        -2781.89990234375,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2767.5,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 1126.19140625,
      "bbox_min": [
        -840.5,
        -2781.88818359375,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2767.5,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        -0.1950865238904953,
        0.0
      ],
      "plane_d": -1360.811767578125,
      "bbox_min": [
        -836.8701171875,
        -2781.88818359375,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2768.11181640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807860255241394,
        0.1950865238904953,
        0.0
      ],
      "plane_d": -278.08160400390625,
      "bbox_min": [
        -836.8701171875,
        -2781.88818359375,
        718.0
      ],
      "bbox_max": [
        -835.5,
        -2775.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        0.9793003797531128,
        -0.0
      ],
      "plane_d": 2871.710693359375,
      "bbox_min": [
        -853.0,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -846.61181640625,
        -2754.101806640625,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 743.9999389648438,
      "bbox_min": [
        -853.0,
        -2756.999755859375,
        744.0
      ],
      "bbox_max": [
        -848.6626586914062,
        -2754.101806640625,
        744.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555502772331238,
        0.8314830660820007,
        -0.0
      ],
      "plane_d": 2749.292724609375,
      "bbox_min": [
        -871.5,
        -2790.5,
        764.5958862304688
      ],
      "bbox_max": [
        -860.38818359375,
        -2727.72802734375,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1815.5491943359375,
      "bbox_min": [
        -871.5,
        -2790.5,
        767.7196044921875
      ],
      "bbox_max": [
        -860.38818359375,
        -2758.3701171875,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9517086744308472,
        -0.3070027828216553,
        0.0
      ],
      "plane_d": -1683.250244140625,
      "bbox_min": [
        -871.5,
        -2790.5,
        780.9169921875
      ],
      "bbox_max": [
        -868.5,
        -2781.199951171875,
        792.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1815.5491943359375,
      "bbox_min": [
        -866.22802734375,
        -2762.27197265625,
        762.0442504882812
      ],
      "bbox_max": [
        -860.38818359375,
        -2758.3701171875,
        774.974365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.4190673828125,
        -2735.60986328125,
        743.3988647460938
      ],
      "bbox_max": [
        -853.0,
        -2733.896728515625,
        744.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9188836812973022,
        0.3240675628185272,
        0.22501777112483978
      ],
      "plane_d": -51.82562255859375,
      "bbox_min": [
        -871.5,
        -2841.150634765625,
        720.0
      ],
      "bbox_max": [
        -853.125,
        -2784.784912109375,
        765.134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -864.6350708007812,
        -2795.0,
        720.0
      ],
      "bbox_max": [
        -853.5,
        -2791.659423828125,
        765.134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -871.5,
        -2830.819580078125,
        720.0
      ],
      "bbox_max": [
        -855.1436767578125,
        -2784.784912109375,
        762.8601684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -866.8314208984375,
        -2792.40966796875,
        720.0
      ],
      "bbox_max": [
        -862.1342163085938,
        -2791.00048828125,
        731.29296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -863.8129272460938,
        -2794.5068359375,
        731.0691528320312
      ],
      "bbox_max": [
        -855.1436767578125,
        -2791.906005859375,
        762.8601684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873479127883911,
        -0.9578263163566589,
        -0.0
      ],
      "plane_d": -2922.376220703125,
      "bbox_min": [
        -871.5,
        -2799.7216796875,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        782.2899780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        0.8314830660820007,
        -0.0
      ],
      "plane_d": 2749.292724609375,
      "bbox_min": [
        -871.5,
        -2765.79443359375,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        778.3818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766169011592865,
        -0.9609803557395935,
        0.0
      ],
      "plane_d": -2387.690185546875,
      "bbox_min": [
        -871.5,
        -2765.79443359375,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2731.6298828125,
        778.3818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314489126205444,
        -0.555601179599762,
        0.0
      ],
      "plane_d": -802.3280029296875,
      "bbox_min": [
        -860.94384765625,
        -2732.46142578125,
        718.0
      ],
      "bbox_max": [
        -859.685791015625,
        -2731.6298828125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -860.94384765625,
        -2732.46142578125,
        730.0
      ],
      "bbox_max": [
        -859.685791015625,
        -2731.6298828125,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314489126205444,
        0.555601179599762,
        -0.0
      ],
      "plane_d": 2247.92236328125,
      "bbox_min": [
        -871.5,
        -2765.79443359375,
        718.0
      ],
      "bbox_max": [
        -859.685791015625,
        -2754.5,
        778.3818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -871.5,
        -2765.79443359375,
        718.0
      ],
      "bbox_max": [
        -866.1742553710938,
        -2754.5,
        778.3818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -871.5,
        -2765.79443359375,
        718.0
      ],
      "bbox_max": [
        -866.5692138671875,
        -2762.5,
        719.4642333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -860.94384765625,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -859.685791015625,
        -2757.53857421875,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -871.5,
        -2757.90087890625,
        719.0
      ],
      "bbox_max": [
        -853.0,
        -2732.09912109375,
        775.5166015625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -871.5,
        -2755.00927734375,
        773.5863647460938
      ],
      "bbox_max": [
        -869.7310791015625,
        -2751.4150390625,
        775.5166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9333456754684448,
        -0.35897910594940186
      ],
      "plane_d": 2821.6474609375,
      "bbox_min": [
        -871.5,
        -2742.0,
        731.0
      ],
      "bbox_max": [
        -853.0,
        -2732.46142578125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2850.166015625,
      "bbox_min": [
        -860.94384765625,
        -2733.000244140625,
        731.0
      ],
      "bbox_max": [
        -858.3370361328125,
        -2732.46142578125,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -871.5,
        -2757.90087890625,
        720.5
      ],
      "bbox_max": [
        -858.3370361328125,
        -2732.09912109375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 869.5,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -869.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -869.5,
        -2741.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -871.5,
        -2748.5,
        720.5
      ],
      "bbox_max": [
        -869.5,
        -2748.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2850.166015625,
      "bbox_min": [
        -860.94384765625,
        -2757.90087890625,
        730.0
      ],
      "bbox_max": [
        -858.3370361328125,
        -2732.09912109375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 729.9999389648438,
      "bbox_min": [
        -860.94384765625,
        -2733.000244140625,
        730.0
      ],
      "bbox_max": [
        -858.3370361328125,
        -2732.09912109375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20241229236125946,
        0.9793003797531128,
        0.0
      ],
      "plane_d": 2526.19287109375,
      "bbox_min": [
        -860.94384765625,
        -2757.90087890625,
        730.0
      ],
      "bbox_max": [
        -858.3373413085938,
        -2756.999755859375,
        731.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -860.94384765625,
        -2757.90087890625,
        730.0
      ],
      "bbox_max": [
        -858.3373413085938,
        -2756.999755859375,
        730.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 719.5,
      "bbox_min": [
        -869.5,
        -2748.5,
        719.0
      ],
      "bbox_max": [
        -865.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        -869.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -867.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 867.5,
      "bbox_min": [
        -869.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -867.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.5,
      "bbox_min": [
        -869.5,
        -2748.5,
        719.5
      ],
      "bbox_max": [
        -867.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -869.5,
        -2741.5,
        719.5
      ],
      "bbox_max": [
        -867.5,
        -2741.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -719.0,
      "bbox_min": [
        -867.5,
        -2748.5,
        719.0
      ],
      "bbox_max": [
        -865.5,
        -2741.5,
        719.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2850.166015625,
      "bbox_min": [
        -871.5,
        -2736.566162109375,
        720.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        -0.9793003797531128,
        0.0
      ],
      "plane_d": -2504.648193359375,
      "bbox_min": [
        -871.5,
        -2734.018798828125,
        720.0
      ],
      "bbox_max": [
        -853.0,
        -2712.0,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -871.5,
        -2713.5,
        720.0
      ],
      "bbox_max": [
        -870.0,
        -2712.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -853.5,
        -2734.018798828125,
        744.0
      ],
      "bbox_max": [
        -853.4099731445312,
        -2733.9833984375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -858.3370361328125,
        -2736.566162109375,
        744.0
      ],
      "bbox_max": [
        -853.0,
        -2733.000244140625,
        744.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -871.5,
        -2791.90625,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2753.433837890625,
        782.2899780273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -871.5,
        -2791.90625,
        718.0
      ],
      "bbox_max": [
        -853.0,
        -2753.433837890625,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20241229236125946,
        0.9793003797531128,
        -0.0
      ],
      "plane_d": 2871.710693359375,
      "bbox_min": [
        -860.38818359375,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2755.896484375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -860.38818359375,
        -2758.3701171875,
        730.0
      ],
      "bbox_max": [
        -853.0,
        -2756.0,
        730.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 743.9999389648438,
      "bbox_min": [
        -853.5,
        -2756.103271484375,
        744.0
      ],
      "bbox_max": [
        -853.0,
        -2755.896484375,
        744.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -858.3373413085938,
        -2756.999755859375,
        744.0
      ],
      "bbox_max": [
        -853.0,
        -2753.433837890625,
        744.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        3.46370114812089e-07,
        0.40613844990730286,
        0.9138115644454956
      ],
      "plane_d": 465.8411865234375,
      "bbox_min": [
        -871.5,
        -2826.99072265625,
        726.3111572265625
      ],
      "bbox_max": [
        -865.5252685546875,
        -2781.199951171875,
        784.2052612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -871.5,
        -2788.75,
        781.3698120117188
      ],
      "bbox_max": [
        -869.0645141601562,
        -2781.199951171875,
        784.2052612304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        -1070.0,
        -2859.5,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -839.0,
      "bbox_min": [
        -1013.125,
        -2852.0,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2776.68798828125,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1013.125,
        -2788.75,
        760.0
      ],
      "bbox_max": [
        -1012.9199829101562,
        -2776.68798828125,
        762.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -989.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2830.0,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 989.0,
      "bbox_min": [
        -989.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2830.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -989.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2844.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -980.0,
        -2844.0,
        839.0
      ],
      "bbox_max": [
        -970.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8648011088371277,
        0.433379590511322,
        0.25357678532600403
      ],
      "plane_d": 1891.3072509765625,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230919003486633,
        -0.23741605877876282,
        -0.6486691832542419
      ],
      "plane_d": 565.3014526367188,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1013.125,
        -2788.75,
        760.0
      ],
      "bbox_max": [
        -1012.7234497070312,
        -2777.22900390625,
        762.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2776.0,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -983.2022094726562,
        -2859.5,
        792.8878784179688
      ],
      "bbox_max": [
        -970.0,
        -2818.693115234375,
        810.2523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        -0.5812382102012634,
        0.0
      ],
      "plane_d": -816.0584106445312,
      "bbox_min": [
        -1013.125,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2776.0,
        790.7488403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2790.0,
      "bbox_min": [
        -1013.125,
        -2790.0,
        760.0
      ],
      "bbox_max": [
        -990.0,
        -2779.8427734375,
        784.6699829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1013.125,
        -2789.0185546875,
        760.0
      ],
      "bbox_max": [
        -1012.0335693359375,
        -2779.8427734375,
        762.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.606892050811439e-06,
        0.4061366319656372,
        0.9138123393058777
      ],
      "plane_d": 465.8314208984375,
      "bbox_min": [
        -977.939697265625,
        -2859.5,
        760.0
      ],
      "bbox_max": [
        -970.0,
        -2857.0,
        761.111083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2774.0,
      "bbox_min": [
        -1070.0,
        -2857.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8552238941192627,
        0.42890995740890503,
        0.29090940952301025
      ],
      "plane_d": 1840.6619873046875,
      "bbox_min": [
        -1070.0,
        -2857.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2774.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 735.0,
      "bbox_min": [
        -1070.0,
        -2800.0,
        720.0
      ],
      "bbox_max": [
        -1004.9564819335938,
        -2774.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1020.0,
        -2776.0,
        735.0
      ],
      "bbox_max": [
        -1010.058837890625,
        -2776.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 734.0,
      "bbox_min": [
        -1062.5,
        -2795.0,
        734.0
      ],
      "bbox_max": [
        -1060.0,
        -2785.0,
        734.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1052.0,
      "bbox_min": [
        -1070.0,
        -2785.0,
        720.0
      ],
      "bbox_max": [
        -1004.9564819335938,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -723.0,
      "bbox_min": [
        -1070.0,
        -2785.0,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 722.5,
      "bbox_min": [
        -1070.0,
        -2778.0,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1053.0,
      "bbox_min": [
        -1053.0,
        -2778.0,
        722.5
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1053.0,
        -2775.5,
        722.5
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1070.0,
        -2776.5,
        720.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        722.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5812382102012634,
        0.0,
        -0.8137334585189819
      ],
      "plane_d": 1201.128662109375,
      "bbox_min": [
        -1058.5,
        -2776.5,
        720.0
      ],
      "bbox_max": [
        -1055.0,
        -2775.5,
        722.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1069.0,
      "bbox_min": [
        -1070.0,
        -2785.0,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1070.0,
        -2775.5,
        723.0
      ],
      "bbox_max": [
        -1069.0,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6726809740066528,
        0.0,
        -0.739932656288147
      ],
      "plane_d": 1260.7265625,
      "bbox_min": [
        -1069.0,
        -2785.0,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2775.499755859375,
      "bbox_min": [
        -1069.0,
        -2775.5,
        732.0
      ],
      "bbox_max": [
        -1065.7000732421875,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6237319111824036,
        -0.7432824969291687,
        0.24184662103652954
      ],
      "plane_d": -1575.1790771484375,
      "bbox_min": [
        -1068.9615478515625,
        -2785.0,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2774.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15551012754440308,
        0.18531674146652222,
        0.9702960252761841
      ],
      "plane_d": -356.4674377441406,
      "bbox_min": [
        -1068.9615478515625,
        -2778.345703125,
        723.0
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.9541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1068.57275390625,
        -2778.345703125,
        723.0
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.9541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7660439610481262,
        0.642788290977478,
        -8.769334272074047e-06
      ],
      "plane_d": 2599.7958984375,
      "bbox_min": [
        -1067.0999755859375,
        -2776.5,
        723.7416381835938
      ],
      "bbox_max": [
        -1064.0916748046875,
        -2774.0,
        726.9541625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.199951171875,
      "bbox_min": [
        -1067.0999755859375,
        -2776.5,
        723.8137817382812
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        725.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1065.800048828125,
      "bbox_min": [
        -1065.800048828125,
        -2776.5,
        724.0221557617188
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        725.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144803524017334,
        0.0,
        0.8575021624565125
      ],
      "plane_d": -72.15533447265625,
      "bbox_min": [
        -1068.0999755859375,
        -2777.5,
        723.0
      ],
      "bbox_max": [
        -1064.800048828125,
        -2774.199951171875,
        724.2703857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": 807.29736328125,
      "bbox_min": [
        -1068.0999755859375,
        -2777.5,
        723.0
      ],
      "bbox_max": [
        -1064.800048828125,
        -2774.199951171875,
        723.93310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5144803524017334,
        0.8575021624565125
      ],
      "plane_d": -2048.943359375,
      "bbox_min": [
        -1068.0999755859375,
        -2777.5,
        723.0
      ],
      "bbox_max": [
        -1064.800048828125,
        -2776.5,
        723.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.199951171875,
      "bbox_min": [
        -1067.0999755859375,
        -2775.199951171875,
        723.5999755859375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        723.93310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1065.800048828125,
      "bbox_min": [
        -1066.35546875,
        -2776.5,
        723.5999755859375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        724.2703857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.199951171875,
      "bbox_min": [
        -1066.35546875,
        -2775.199951171875,
        723.5999755859375
      ],
      "bbox_max": [
        -1065.800048828125,
        -2775.199951171875,
        724.0221557617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2775.5,
      "bbox_min": [
        -1062.5,
        -2785.0,
        723.0
      ],
      "bbox_max": [
        -1052.0,
        -2775.5,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6896594166755676,
        -0.0,
        0.7241339683532715
      ],
      "plane_d": 195.421142578125,
      "bbox_min": [
        -1062.5,
        -2785.0,
        733.0
      ],
      "bbox_max": [
        -1053.0,
        -2775.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 734.0,
      "bbox_min": [
        -1062.5,
        -2785.0,
        734.0
      ],
      "bbox_max": [
        -1060.0,
        -2777.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2483.359130859375,
      "bbox_min": [
        -1062.5,
        -2778.0,
        734.0
      ],
      "bbox_max": [
        -1060.0,
        -2777.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        -1060.0,
        -2778.0,
        734.0
      ],
      "bbox_max": [
        -1060.0,
        -2777.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1051.0,
        -2776.5,
        720.0
      ],
      "bbox_max": [
        -1004.9564819335938,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2481.94482421875,
      "bbox_min": [
        -1051.0,
        -2776.0,
        734.0
      ],
      "bbox_max": [
        -1047.0,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2481.94482421875,
      "bbox_min": [
        -1051.0,
        -2776.5,
        733.5
      ],
      "bbox_max": [
        -1047.0,
        -2776.0,
        734.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.606892050811439e-06,
        0.4061366319656372,
        0.9138123393058777
      ],
      "plane_d": 465.8314208984375,
      "bbox_min": [
        -1018.5626831054688,
        -2857.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2774.0,
        760.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2776.0,
      "bbox_min": [
        -1006.317138671875,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -978.9999389648438,
        -2774.0,
        724.000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2776.0,
        720.0
      ],
      "bbox_max": [
        -978.9999389648438,
        -2774.0,
        724.000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -979.22216796875,
        -2776.0,
        723.1113891601562
      ],
      "bbox_max": [
        -970.0,
        -2774.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9355461001396179,
        0.10546036809682846,
        0.3370926082134247
      ],
      "plane_d": 984.2843017578125,
      "bbox_min": [
        -1012.960693359375,
        -2791.787109375,
        724.0000610351562
      ],
      "bbox_max": [
        -1000.0377197265625,
        -2776.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9322125315666199,
        0.07008834928274155,
        0.35505980253219604
      ],
      "plane_d": 869.0626220703125,
      "bbox_min": [
        -1012.960693359375,
        -2791.787109375,
        731.0165405273438
      ],
      "bbox_max": [
        -1000.7862548828125,
        -2776.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -993.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2766.0,
      "bbox_min": [
        -993.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -990.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2766.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -990.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -979.2222900390625,
        -2767.0,
        723.111083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5216583051369525e-06,
        0.40613892674446106,
        0.9138113260269165
      ],
      "plane_d": 465.84381103515625,
      "bbox_min": [
        -980.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2767.0,
        723.111083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2720.0,
      "bbox_min": [
        -993.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701426029205322,
        0.0,
        -0.24253565073013306
      ],
      "plane_d": 1125.365478515625,
      "bbox_min": [
        -980.0,
        -2720.0,
        720.0
      ],
      "bbox_max": [
        -970.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 990.0,
      "bbox_min": [
        -993.0,
        -2766.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2720.0,
        760.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2724.0,
      "bbox_min": [
        -993.0,
        -2762.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2762.0,
      "bbox_min": [
        -993.0,
        -2762.0,
        720.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 756.0,
      "bbox_min": [
        -993.0,
        -2762.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1393.7076416015625,
      "bbox_min": [
        -993.0,
        -2762.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2724.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2485.48046875,
      "bbox_min": [
        -993.0,
        -2762.0,
        753.0
      ],
      "bbox_max": [
        -990.0,
        -2759.0,
        756.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 758.0,
      "bbox_min": [
        -1070.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1060.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1070.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1060.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2402.129150390625,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1060.0,
        -2712.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1064.5,
        -2728.5,
        750.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -628.4752807617188,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1067.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        -1070.0,
        -2736.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1067.0,
        -2728.5,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 745.0,
      "bbox_min": [
        -1070.0,
        -2736.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1068.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.0,
      "bbox_min": [
        -1070.0,
        -2735.0,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2728.5,
      "bbox_min": [
        -1070.0,
        -2728.5,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2728.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2736.5,
      "bbox_min": [
        -1070.0,
        -2736.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1069.0001220703125,
        -2736.5,
        731.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2414.60986328125,
      "bbox_min": [
        -1070.0,
        -2757.5,
        720.0
      ],
      "bbox_max": [
        -1067.0,
        -2733.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        -1070.0,
        -2757.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1067.0,
        -2749.5,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 745.0,
      "bbox_min": [
        -1070.0,
        -2757.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1068.0,
        -2749.5,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2751.0,
      "bbox_min": [
        -1070.0,
        -2751.0,
        745.0
      ],
      "bbox_max": [
        -1068.0,
        -2751.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2749.5,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.6666870117188
      ],
      "bbox_max": [
        -1069.0,
        -2749.5,
        731.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.0,
      "bbox_min": [
        -1070.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1067.0,
        -2733.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 723.0,
      "bbox_min": [
        -1068.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1067.0,
        -2733.5,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2742.0,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2736.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2736.5,
      "bbox_min": [
        -1069.0001220703125,
        -2736.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2736.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2744.0,
      "bbox_min": [
        -1070.0,
        -2749.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2744.0,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2749.5,
      "bbox_min": [
        -1069.0,
        -2749.5,
        727.0
      ],
      "bbox_max": [
        -1067.0,
        -2749.5,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161494255066,
        -0.0,
        0.9805806875228882
      ],
      "plane_d": -500.68450927734375,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 722.9999389648438,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1064.5,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3713906705379486,
        -0.9284766912460327,
        0.0
      ],
      "plane_d": -2159.358154296875,
      "bbox_min": [
        -1067.0,
        -2752.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284766912460327,
        0.0
      ],
      "plane_d": 2934.264892578125,
      "bbox_min": [
        -1067.0,
        -2734.5,
        723.0
      ],
      "bbox_max": [
        -1064.5,
        -2733.5,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1070.0,
        -2720.5,
        754.5
      ],
      "bbox_max": [
        -1060.0,
        -2712.0,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1070.0,
        -2774.0,
        723.6817016601562
      ],
      "bbox_max": [
        -1060.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1070.0,
        -2769.0,
        754.5
      ],
      "bbox_max": [
        -1060.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15549609065055847,
        -0.18532346189022064,
        -0.9702969789505005
      ],
      "plane_d": 353.93450927734375,
      "bbox_min": [
        -1066.4940185546875,
        -2774.0,
        723.6817016601562
      ],
      "bbox_max": [
        -1066.1202392578125,
        -2773.81591796875,
        723.7416381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2716.5,
      "bbox_min": [
        -1060.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 756.5,
      "bbox_min": [
        -1060.0,
        -2716.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1058.0,
        -2716.5,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2715.5,
      "bbox_min": [
        -1060.0,
        -2716.5,
        720.0
      ],
      "bbox_max": [
        -1009.5,
        -2712.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1060.0,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -1009.5,
        -2712.0,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        -1060.0,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -1030.0,
        -2712.0,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2714.5,
      "bbox_min": [
        -1060.0,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -2691.970703125,
      "bbox_min": [
        -1060.0,
        -2714.5,
        736.0
      ],
      "bbox_max": [
        -1040.0,
        -2712.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2714.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2712.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1060.0,
        -2715.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2714.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2715.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2714.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2714.5,
      "bbox_min": [
        -1035.0,
        -2714.5,
        720.0
      ],
      "bbox_max": [
        -1030.0,
        -2712.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -2691.970703125,
      "bbox_min": [
        -1035.0,
        -2714.5,
        736.0
      ],
      "bbox_max": [
        -1030.0,
        -2712.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        -1025.0,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -1009.5,
        -2712.0,
        754.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2714.5,
      "bbox_min": [
        -1025.0,
        -2714.5,
        720.0
      ],
      "bbox_max": [
        -1020.0,
        -2712.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -2691.970703125,
      "bbox_min": [
        -1025.0,
        -2714.5,
        736.0
      ],
      "bbox_max": [
        -1020.0,
        -2712.0,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1020.0,
        -2715.5,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2712.0,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1020.0,
        -2715.5,
        754.5
      ],
      "bbox_max": [
        -1009.5,
        -2712.0,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1060.0,
        -2716.5,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2715.5,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1058.0,
      "bbox_min": [
        -1058.0,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2715.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1020.0,
        -2716.5,
        725.5
      ],
      "bbox_max": [
        -1009.5,
        -2715.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1009.5,
        -2716.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2712.0,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1060.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1058.0,
        -2763.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2774.0,
        756.5
      ],
      "bbox_max": [
        -1058.0,
        -2769.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        -1060.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1034.5,
        -2769.5,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2771.5,
      "bbox_min": [
        -1060.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1040.0,
        -2769.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 1960.148193359375,
      "bbox_min": [
        -1060.0,
        -2774.0,
        736.0
      ],
      "bbox_max": [
        -1040.0,
        -2771.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2774.0,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2771.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1060.0,
        -2771.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2769.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1058.0,
        -2771.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2769.5,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2771.5,
      "bbox_min": [
        -1035.0,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1034.5,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 1960.148193359375,
      "bbox_min": [
        -1035.0,
        -2774.0,
        736.0
      ],
      "bbox_max": [
        -1034.5,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1057.9998779296875,
      "bbox_min": [
        -1060.0,
        -2769.5,
        754.5
      ],
      "bbox_max": [
        -1058.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        -1020.0,
        -2774.0,
        758.0
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1020.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1010.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1020.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1010.0,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2724.5,
      "bbox_min": [
        -1018.0,
        -2724.5,
        758.0
      ],
      "bbox_max": [
        -1010.0,
        -2724.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1387.6971435546875,
      "bbox_min": [
        -1010.0,
        -2765.5,
        758.0
      ],
      "bbox_max": [
        -1008.0,
        -2720.5,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1009.5,
      "bbox_min": [
        -1034.5,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2770.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        -1034.5,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1009.5,
        -2770.5,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2771.5,
      "bbox_min": [
        -1034.5,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1020.0,
        -2770.5,
        756.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        -1034.5,
        -2774.0,
        720.0
      ],
      "bbox_max": [
        -1020.0,
        -2771.5,
        740.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 1960.148193359375,
      "bbox_min": [
        -1034.5,
        -2774.0,
        736.0
      ],
      "bbox_max": [
        -1030.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 1960.148193359375,
      "bbox_min": [
        -1025.0,
        -2774.0,
        736.0
      ],
      "bbox_max": [
        -1020.0,
        -2771.5,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1009.5,
        -2774.0,
        725.5
      ],
      "bbox_max": [
        -1008.0,
        -2770.5,
        754.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1020.0,
        -2722.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2722.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1444.9727783203125,
      "bbox_min": [
        -1034.5,
        -2770.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.5,
      "bbox_min": [
        -1020.0,
        -2770.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2770.5,
        720.0
      ],
      "bbox_max": [
        -1008.0,
        -2763.5,
        725.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2491.49072265625,
      "bbox_min": [
        -1034.5,
        -2770.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 756.5,
      "bbox_min": [
        -1034.5,
        -2770.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2770.5,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2769.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2769.5,
        756.5
      ],
      "bbox_max": [
        -1008.0,
        -2765.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 754.5,
      "bbox_min": [
        -1020.0,
        -2770.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2767.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1007.9999389648438,
      "bbox_min": [
        -1008.0,
        -2770.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2767.0,
        756.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1008.0,
      "bbox_min": [
        -1008.0,
        -2720.5,
        754.5
      ],
      "bbox_max": [
        -1008.0,
        -2716.5,
        758.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1068.0,
      "bbox_min": [
        -1068.0,
        -2764.0,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        718.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2764.0,
      "bbox_min": [
        -1068.0,
        -2764.0,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        718.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 2706.804931640625,
      "bbox_min": [
        -1068.0,
        -2764.0,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        718.6666870117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -640.9561157226562,
      "bbox_min": [
        -1068.0,
        -2757.5,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        715.77783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1068.0,
        -2756.0,
        680.0
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        715.111083984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2414.60986328125,
      "bbox_min": [
        -1068.0,
        -2752.5,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2725.0,
        713.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -628.4752807617188,
      "bbox_min": [
        -1068.0,
        -2735.0,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2725.0,
        705.7777099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2402.129150390625,
      "bbox_min": [
        -1068.0,
        -2730.0,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2725.0,
        703.5555419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1172.3831787109375,
      "bbox_min": [
        -1068.0,
        -2726.0,
        680.0
      ],
      "bbox_max": [
        -1067.0,
        -2725.0,
        701.77783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1172.3831787109375,
      "bbox_min": [
        -1067.0,
        -2725.0,
        680.0
      ],
      "bbox_max": [
        -1064.0,
        -2722.0,
        701.3333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1172.3831787109375,
      "bbox_min": [
        -1068.0,
        -2764.0,
        699.9999389648438
      ],
      "bbox_max": [
        -1046.5,
        -2722.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2764.0,
      "bbox_min": [
        -1068.0,
        -2764.0,
        702.8888549804688
      ],
      "bbox_max": [
        -1046.5,
        -2728.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2402.129150390625,
      "bbox_min": [
        -1068.0,
        -2764.0,
        702.8888549804688
      ],
      "bbox_max": [
        -1064.0,
        -2728.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -628.4752807617188,
      "bbox_min": [
        -1068.0,
        -2764.0,
        703.5555419921875
      ],
      "bbox_max": [
        -1064.0,
        -2730.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1067.0,
        -2733.5,
        703.5555419921875
      ],
      "bbox_max": [
        -1067.0,
        -2730.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 2414.60986328125,
      "bbox_min": [
        -1068.0,
        -2764.0,
        712.888916015625
      ],
      "bbox_max": [
        -1064.0,
        -2751.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 2706.804931640625,
      "bbox_min": [
        -1068.0,
        -2764.0,
        713.5555419921875
      ],
      "bbox_max": [
        -1064.0,
        -2752.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1067.0,
      "bbox_min": [
        -1068.0,
        -2757.5,
        713.5555419921875
      ],
      "bbox_max": [
        -1067.0,
        -2752.5,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320503234863281,
        -0.5547001957893372,
        0.0
      ],
      "plane_d": -640.9561157226562,
      "bbox_min": [
        -1068.0,
        -2757.5,
        715.111083984375
      ],
      "bbox_max": [
        -1067.0,
        -2756.0,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.40613847970962524,
        0.9138115644454956
      ],
      "plane_d": 465.8408203125,
      "bbox_min": [
        -970.0,
        -2859.5,
        670.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        844.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.857492983341217,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4620361328125,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -885.3666381835938,
        -2766.999755859375,
        723.5556030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -970.0,
        -2859.5,
        695.5555419921875
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -894.0,
        -2854.677490234375,
        766.400146484375
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        811.0656127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -884.5228271484375,
        -2747.351318359375,
        766.400146484375
      ],
      "bbox_max": [
        -873.5,
        -2719.897216796875,
        783.1830444335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -878.5,
      "bbox_min": [
        -894.0,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        745.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -878.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        745.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -878.5,
        -2775.0,
        735.0
      ],
      "bbox_max": [
        -873.5,
        -2715.5,
        745.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2715.5,
      "bbox_min": [
        -878.5,
        -2715.5,
        735.0
      ],
      "bbox_max": [
        -873.5,
        -2715.5,
        745.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -874.5,
      "bbox_min": [
        -878.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2715.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -721.0,
      "bbox_min": [
        -874.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2715.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2715.5,
      "bbox_min": [
        -874.5,
        -2715.5,
        720.0
      ],
      "bbox_max": [
        -873.5,
        -2715.5,
        721.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -874.5,
        -2775.0,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2715.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2715.5,
      "bbox_min": [
        -874.5,
        -2715.5,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2715.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.5,
      "bbox_min": [
        -874.5,
        -2775.0,
        721.0
      ],
      "bbox_max": [
        -873.5,
        -2754.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -874.5,
        -2775.0,
        723.5556030273438
      ],
      "bbox_max": [
        -873.5,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -878.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -874.5,
        -2715.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -878.5,
        -2775.0,
        723.5556030273438
      ],
      "bbox_max": [
        -874.5,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -719.9999389648438,
      "bbox_min": [
        -894.0,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2712.0,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        0.0,
        0.5144957900047302
      ],
      "plane_d": -1131.4619140625,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2715.5,
        735.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2735.5,
      "bbox_min": [
        -887.5,
        -2775.0,
        720.0
      ],
      "bbox_max": [
        -878.5,
        -2715.5,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -885.3666381835938,
        -2775.0,
        723.5556030273438
      ],
      "bbox_max": [
        -878.5,
        -2775.0,
        735.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7891456484794617,
        -0.2033252865076065,
        -0.579575777053833
      ],
      "plane_d": -798.1556396484375,
      "bbox_min": [
        -890.8987426757812,
        -2859.5,
        752.0096435546875
      ],
      "bbox_max": [
        -873.5,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9188836812973022,
        0.3240675628185272,
        0.22501777112483978
      ],
      "plane_d": -51.82562255859375,
      "bbox_min": [
        -878.493408203125,
        -2859.5,
        752.0096435546875
      ],
      "bbox_max": [
        -873.5,
        -2839.021728515625,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9069707989692688,
        0.3202887773513794,
        0.27353084087371826
      ],
      "plane_d": -89.20687866210938,
      "bbox_min": [
        -877.9344482421875,
        -2859.5,
        763.2899169921875
      ],
      "bbox_max": [
        -873.5,
        -2846.85400390625,
        778.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.21853138506412506,
        -0.9758298397064209
      ],
      "plane_d": 183.5848388671875,
      "bbox_min": [
        -932.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -914.0,
        -2712.0,
        794.9854736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2788.75,
        762.3236694335938
      ],
      "bbox_max": [
        -914.0,
        -2712.0,
        794.9854736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7484292387962341,
        -0.16308142244815826,
        -0.6428514719009399
      ],
      "plane_d": -602.9218139648438,
      "bbox_min": [
        -897.8980712890625,
        -2788.75,
        790.9302978515625
      ],
      "bbox_max": [
        -894.0,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6743385195732117,
        -0.18642187118530273,
        -0.7145029306411743
      ],
      "plane_d": 708.3369750976562,
      "bbox_min": [
        -970.0,
        -2788.75,
        782.79443359375
      ],
      "bbox_max": [
        -957.3062744140625,
        -2712.0,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7230919003486633,
        -0.23741605877876282,
        -0.6486691832542419
      ],
      "plane_d": 565.3014526367188,
      "bbox_min": [
        -970.0,
        -2718.603271484375,
        782.79443359375
      ],
      "bbox_max": [
        -965.9404907226562,
        -2712.0,
        787.3197021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.34984517097473145,
        0.9368076324462891
      ],
      "plane_d": 230.88226318359375,
      "bbox_min": [
        -932.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.34984517097473145,
        -0.9368076324462891
      ],
      "plane_d": -234.6295166015625,
      "bbox_min": [
        -932.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -914.0,
        -2788.75,
        821.4066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 914.0,
      "bbox_min": [
        -914.0,
        -2859.5,
        790.9854736328125
      ],
      "bbox_max": [
        -914.0,
        -2788.75,
        821.4066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.813399076461792,
        -0.11765268445014954,
        -0.5696839690208435
      ],
      "plane_d": -593.9013671875,
      "bbox_min": [
        -932.0,
        -2859.5,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563967704772949,
        -0.07589671015739441,
        -0.6496949791908264
      ],
      "plane_d": -361.36248779296875,
      "bbox_min": [
        -895.9375,
        -2794.44287109375,
        810.4005737304688
      ],
      "bbox_max": [
        -894.0,
        -2788.75,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.4982432503529708e-06,
        -0.270979642868042,
        -0.9625850319862366
      ],
      "plane_d": 26.5576171875,
      "bbox_min": [
        -932.0,
        -2859.5,
        812.65625
      ],
      "bbox_max": [
        -895.9375,
        -2788.75,
        844.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 918.0,
      "bbox_min": [
        -932.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2853.0,
      "bbox_min": [
        -932.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 927.0,
      "bbox_min": [
        -932.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -919.0,
        -2843.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -839.0,
      "bbox_min": [
        -932.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -927.0,
        -2843.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -928.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        827.9282836914062
      ],
      "bbox_max": [
        -928.0,
        -2843.0,
        837.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -932.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -927.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -932.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -927.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -932.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -927.0,
        -2852.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        828.2097778320312
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        828.2097778320312
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        830.4618530273438
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        844.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        844.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2853.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 918.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -928.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2843.0,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 822.9999389648438,
      "bbox_min": [
        -928.0,
        -2853.0,
        823.0
      ],
      "bbox_max": [
        -918.0,
        -2843.0,
        830.4618530273438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 927.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -919.0,
      "bbox_min": [
        -927.0,
        -2852.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        830.4618530273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -927.0,
        -2844.0,
        823.0
      ],
      "bbox_max": [
        -919.0,
        -2844.0,
        828.2097778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.996506378229242e-07,
        -0.2709798812866211,
        -0.9625849723815918
      ],
      "plane_d": 26.5545654296875,
      "bbox_min": [
        -970.0,
        -2859.5,
        803.5133056640625
      ],
      "bbox_max": [
        -932.0,
        -2788.75,
        844.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 844.0,
      "bbox_min": [
        -970.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -932.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2844.0,
      "bbox_min": [
        -970.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -932.0,
        -2844.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2852.0,
      "bbox_min": [
        -970.0,
        -2852.0,
        839.0
      ],
      "bbox_max": [
        -932.0,
        -2852.0,
        844.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7929525971412659,
        -0.08809126913547516,
        -0.6028815507888794
      ],
      "plane_d": 1005.753173828125,
      "bbox_min": [
        -970.0,
        -2859.5,
        803.5133056640625
      ],
      "bbox_max": [
        -953.0294189453125,
        -2788.75,
        832.5732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6862487196922302,
        -0.018855048343539238,
        -0.72712242603302
      ],
      "plane_d": 1197.331787109375,
      "bbox_min": [
        -970.0,
        -2818.693115234375,
        803.5133056640625
      ],
      "bbox_max": [
        -960.3125,
        -2788.75,
        812.65625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6411095261573792,
        -0.19564983248710632,
        -0.7420914173126221
      ],
      "plane_d": -530.467529296875,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7073557376861572,
        -0.10758212953805923,
        -0.6986229419708252
      ],
      "plane_d": -366.921630859375,
      "bbox_min": [
        -915.298095703125,
        -2969.43994140625,
        823.2562255859375
      ],
      "bbox_max": [
        -886.190185546875,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -915.298095703125,
        -2969.43994140625,
        845.7208251953125
      ],
      "bbox_max": [
        -908.3773803710938,
        -2930.0,
        858.8014526367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022194361314177513,
        0.23613107204437256,
        0.9714676737785339
      ],
      "plane_d": -96.8321533203125,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24552778899669647,
        0.9693895578384399
      ],
      "plane_d": -46.93780517578125,
      "bbox_min": [
        -933.5289916992188,
        -2978.0,
        790.5328369140625
      ],
      "bbox_max": [
        -905.461181640625,
        -2930.0,
        802.8236694335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.3569946289062,
        -2978.0,
        790.5328369140625
      ],
      "bbox_max": [
        -905.461181640625,
        -2930.0,
        802.8236694335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -954.572998046875,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -890.2421875,
        -2930.0,
        818.9484252929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -954.572998046875,
        -2978.0,
        790.4069213867188
      ],
      "bbox_max": [
        -893.0887451171875,
        -2930.0,
        817.5613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -906.232177734375,
        -2978.0,
        791.174072265625
      ],
      "bbox_max": [
        -893.0887451171875,
        -2930.0,
        816.8629150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.4109497070312,
        -2978.0,
        792.7325439453125
      ],
      "bbox_max": [
        -890.2421875,
        -2930.0,
        818.9484252929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6921083927154541,
        -0.23178932070732117,
        -0.6835638880729675
      ],
      "plane_d": 547.8385009765625,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        792.7979125976562
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        792.7979125976562
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        794.1980590820312
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        818.8846435546875
      ],
      "bbox_max": [
        -883.2512817382812,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -893.3917846679688,
        -2978.0,
        838.7080078125
      ],
      "bbox_max": [
        -892.9408569335938,
        -2976.87353515625,
        842.0807495117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -893.3917846679688,
        -2978.0,
        841.642578125
      ],
      "bbox_max": [
        -893.0785522460938,
        -2976.87353515625,
        842.0807495117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -893.377685546875,
        -2978.0,
        841.642578125
      ],
      "bbox_max": [
        -893.0785522460938,
        -2976.87353515625,
        842.0687866210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -962.0082397460938,
        -2978.0,
        818.93994140625
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968570470809937,
        -0.04264342784881592,
        0.06676524132490158
      ],
      "plane_d": 771.4093627929688,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        836.5609130859375
      ],
      "bbox_max": [
        -957.2632446289062,
        -2976.006103515625,
        841.7111206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -957.5886840820312,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -957.2863159179688,
        -2976.006103515625,
        841.7111206054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6902596354484558,
        -0.23094093799591064,
        -0.685716986656189
      ],
      "plane_d": 550.4041748046875,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016984544694423676,
        -0.3070979416370392,
        -0.9515263438224792
      ],
      "plane_d": -79.1907958984375,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3147980272769928,
        -0.9491586685180664
      ],
      "plane_d": -119.635009765625,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -893.16796875,
        -2930.0,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -893.16796875,
        -2969.43994140625,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -957.483642578125,
        -2978.0,
        841.1246948242188
      ],
      "bbox_max": [
        -914.2279052734375,
        -2969.43994140625,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012172247283160686,
        -0.11178828030824661,
        -0.9936575293540955
      ],
      "plane_d": 532.547119140625,
      "bbox_min": [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      "bbox_max": [
        -914.2279052734375,
        -2969.43994140625,
        859.777587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28555822372436523,
        0.010150653310120106,
        -0.9583075642585754
      ],
      "plane_d": 1120.8348388671875,
      "bbox_min": [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      "bbox_max": [
        -934.7142944335938,
        -2970.04833984375,
        859.526611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -962.9921875,
        -3076.67138671875,
        801.9602661132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.718767523765564,
        0.17485763132572174,
        0.6729028224945068
      ],
      "plane_d": -670.8665161132812,
      "bbox_min": [
        -909.0738525390625,
        -2990.6005859375,
        802.6903076171875
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        820.9805908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.016610853374004364,
        0.44841963052749634,
        0.8936688303947449
      ],
      "plane_d": 620.2237548828125,
      "bbox_min": [
        -893.0887451171875,
        -2985.04052734375,
        816.8317260742188
      ],
      "bbox_max": [
        -890.670654296875,
        -2978.0,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.521484375,
        -2985.04052734375,
        816.8317260742188
      ],
      "bbox_max": [
        -890.670654296875,
        -2978.0,
        820.3665161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24552778899669647,
        0.9693895578384399
      ],
      "plane_d": -46.93780517578125,
      "bbox_min": [
        -909.0738525390625,
        -2990.6005859375,
        802.6903076171875
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        820.9805908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9512509107589722,
        0.15018445253372192,
        0.26938122510910034
      ],
      "plane_d": -620.7452392578125,
      "bbox_min": [
        -891.521484375,
        -2985.04052734375,
        819.4458618164062
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        820.9805908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -891.521484375,
        -2985.04052734375,
        820.1769409179688
      ],
      "bbox_max": [
        -890.463623046875,
        -2978.0,
        820.9805908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024503104388713837,
        0.08246573805809021,
        0.9962926506996155
      ],
      "plane_d": -534.0615234375,
      "bbox_min": [
        -962.9921875,
        -3076.67138671875,
        801.9602661132812
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.021621091291308403,
        0.10562144964933395,
        0.9941713809967041
      ],
      "plane_d": -504.9111633300781,
      "bbox_min": [
        -947.5514526367188,
        -3065.553955078125,
        801.9602661132812
      ],
      "bbox_max": [
        -906.4345703125,
        -2978.0,
        813.04150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.022194361314177513,
        0.23613107204437256,
        0.9714676737785339
      ],
      "plane_d": -96.8321533203125,
      "bbox_min": [
        -945.36328125,
        -2990.9130859375,
        801.9602661132812
      ],
      "bbox_max": [
        -906.4345703125,
        -2978.0,
        805.8817749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24552778899669647,
        0.9693895578384399
      ],
      "plane_d": -46.93780517578125,
      "bbox_min": [
        -912.0682983398438,
        -2990.6005859375,
        802.6903076171875
      ],
      "bbox_max": [
        -906.4345703125,
        -2978.0,
        805.8817749023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -945.36328125,
        -2990.9130859375,
        801.9602661132812
      ],
      "bbox_max": [
        -944.0224609375,
        -2978.0,
        805.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7762428522109985,
        0.04481952264904976,
        0.6288387775421143
      ],
      "plane_d": 361.6246032714844,
      "bbox_min": [
        -947.5514526367188,
        -3064.909423828125,
        803.7000732421875
      ],
      "bbox_max": [
        -945.1990356445312,
        -2978.0,
        813.04150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -946.2025146484375,
        -2990.9130859375,
        803.7000732421875
      ],
      "bbox_max": [
        -945.1990356445312,
        -2978.0,
        805.1838989257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -946.9003295898438,
        -2996.380126953125,
        805.068359375
      ],
      "bbox_max": [
        -945.36328125,
        -2978.0,
        807.3554077148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8210588693618774,
        0.007935827597975731,
        0.5707883238792419
      ],
      "plane_d": 340.41064453125,
      "bbox_min": [
        -946.9003295898438,
        -2996.380126953125,
        805.068359375
      ],
      "bbox_max": [
        -945.36328125,
        -2990.2333984375,
        807.3554077148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -962.9921875,
        -3076.67138671875,
        805.8275146484375
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -962.9921875,
        -3073.32177734375,
        805.8275146484375
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -891.6134033203125,
        -2985.04052734375,
        820.3665161132812
      ],
      "bbox_max": [
        -890.571044921875,
        -2978.0,
        828.7779541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -962.9921875,
        -3064.882080078125,
        805.8275146484375
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9808734059333801,
        0.14385229349136353,
        -0.13112545013427734
      ],
      "plane_d": -337.4938659667969,
      "bbox_min": [
        -892.9408569335938,
        -2985.04052734375,
        820.3665161132812
      ],
      "bbox_max": [
        -891.521484375,
        -2978.0,
        838.7080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28555822372436523,
        0.010150653310120106,
        -0.9583075642585754
      ],
      "plane_d": 1120.8348388671875,
      "bbox_min": [
        -962.9921875,
        -3064.882080078125,
        805.8275146484375
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -962.9921875,
        -3064.882080078125,
        805.8275146484375
      ],
      "bbox_max": [
        -886.54736328125,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6384236216545105,
        -0.16553433239459991,
        -0.7516739964485168
      ],
      "plane_d": -430.353515625,
      "bbox_min": [
        -962.9921875,
        -3064.882080078125,
        805.8275146484375
      ],
      "bbox_max": [
        -893.377685546875,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012172247283160686,
        -0.11178828030824661,
        -0.9936575293540955
      ],
      "plane_d": 532.547119140625,
      "bbox_min": [
        -962.9921875,
        -3064.882080078125,
        805.8275146484375
      ],
      "bbox_max": [
        -905.8515625,
        -2978.0,
        867.4175415039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6870704293251038,
        -0.14160729944705963,
        -0.712658166885376
      ],
      "plane_d": 835.868896484375,
      "bbox_min": [
        -962.9921875,
        -3064.882080078125,
        805.8275146484375
      ],
      "bbox_max": [
        -940.6383056640625,
        -2978.0,
        857.7613525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9939219355583191,
        -0.10033050924539566,
        -0.045308977365493774
      ],
      "plane_d": 688.4334716796875,
      "bbox_min": [
        -962.9921875,
        -3064.882080078125,
        805.8275146484375
      ],
      "bbox_max": [
        -946.6009521484375,
        -2978.0,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968570470809937,
        -0.04264342784881592,
        0.06676524132490158
      ],
      "plane_d": 771.4093627929688,
      "bbox_min": [
        -961.00341796875,
        -3042.81494140625,
        817.5243530273438
      ],
      "bbox_max": [
        -955.98681640625,
        -2978.0,
        851.0064086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9949972033500671,
        0.09980414807796478,
        0.004440675489604473
      ],
      "plane_d": 1245.9761962890625,
      "bbox_min": [
        -957.2632446289062,
        -2984.7890625,
        817.5243530273438
      ],
      "bbox_max": [
        -955.98681640625,
        -2978.0,
        836.5609130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -957.1927490234375,
        -2984.7890625,
        817.5243530273438
      ],
      "bbox_max": [
        -955.98681640625,
        -2978.0,
        821.0216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9567331075668335,
        0.10609757900238037,
        0.27093374729156494
      ],
      "plane_d": 1009.364013671875,
      "bbox_min": [
        -957.1927490234375,
        -2984.7890625,
        817.5243530273438
      ],
      "bbox_max": [
        -956.2754516601562,
        -2978.0,
        821.0216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8210588693618774,
        0.007935827597975731,
        0.5707883238792419
      ],
      "plane_d": 340.41064453125,
      "bbox_min": [
        -962.9921875,
        -3064.882080078125,
        805.8275146484375
      ],
      "bbox_max": [
        -946.6009521484375,
        -2978.0,
        831.2987060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273747563362122,
        0.04876469075679779,
        0.5595293641090393
      ],
      "plane_d": 477.5612487792969,
      "bbox_min": [
        -956.512939453125,
        -2990.2333984375,
        805.8275146484375
      ],
      "bbox_max": [
        -946.6009521484375,
        -2978.0,
        821.0216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019330233335494995,
        0.45839300751686096,
        0.8885392546653748
      ],
      "plane_d": 620.2069091796875,
      "bbox_min": [
        -956.512939453125,
        -2984.7890625,
        817.5306396484375
      ],
      "bbox_max": [
        -954.572998046875,
        -2978.0,
        821.0216064453125
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}